export const favorites: any = {
  tvSeason: [
    {
      wrapperType: 'collection',
      collectionType: 'TV Season',
      artistId: 1173812719,
      collectionId: 1502676025,
      artistName: 'Westworld',
      collectionName: 'Westworld, Season 3',
      collectionCensoredName: 'Westworld, Season 3',
      artistViewUrl:
        'https://itunes.apple.com/us/tv-show/westworld/id1173812719?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/tv-season/westworld-season-3/id1502676025?uo=4',
      artworkUrl60:
        'https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/c0/92/71/c09271da-a001-c309-6279-80fffe21c183/source/60x60bb.jpg',
      artworkUrl100:
        'https://is1-ssl.mzstatic.com/image/thumb/Music113/v4/c0/92/71/c09271da-a001-c309-6279-80fffe21c183/source/100x100bb.jpg',
      collectionPrice: 22.99,
      collectionHdPrice: 29.99,
      collectionExplicitness: 'notExplicit',
      trackCount: 23,
      copyright: '© 2020 Warner Bros. Entertainment Inc.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2020-03-15T07:00:00Z',
      primaryGenreName: 'Sci-Fi & Fantasy',
      longDescription:
        'Escape is not freedom. Welcome back to Westworld, the Emmy®-winning drama series that follows the dawn of artificial consciousness and the evolution of sin. In Season Three, the real gods are coming... and they are very angry. Born into a world of pain, Westworld’s android hosts were never allowed to go or see one place: our world. But now, at the end of the game, they’re here.',
    },
    {
      wrapperType: 'collection',
      collectionType: 'TV Season',
      artistId: 689571082,
      collectionId: 1512011568,
      artistName: "Marvel's Agents of S.H.I.E.L.D.",
      collectionName: "Marvel's Agents of S.H.I.E.L.D., Season 7",
      collectionCensoredName: "Marvel's Agents of S.H.I.E.L.D., Season 7",
      artistViewUrl:
        'https://itunes.apple.com/us/tv-show/marvels-agents-of-s-h-i-e-l-d/id689571082?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/tv-season/marvels-agents-of-s-h-i-e-l-d-season-7/id1512011568?uo=4',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Music113/v4/d4/93/55/d4935548-23d8-9aaf-f72b-b206307ddda8/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Music113/v4/d4/93/55/d4935548-23d8-9aaf-f72b-b206307ddda8/source/100x100bb.jpg',
      collectionPrice: 22.99,
      collectionHdPrice: 29.99,
      collectionExplicitness: 'notExplicit',
      contentAdvisoryRating: 'TV-14',
      trackCount: 13,
      copyright: '© ABC Studios/Marvel Television',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2020-05-28T07:00:00Z',
      primaryGenreName: 'Drama',
      longDescription:
        'Coulson and the Agents of S.H.I.E.L.D. are thrust backward in time and stranded in 1931 New York City. With the all-new Zephyr set to time-jump at any moment, the team must hurry to find out exactly what happened. If they fail, it would mean disaster for the past, present and future of the world.',
    },
    {
      wrapperType: 'collection',
      collectionType: 'TV Season',
      artistId: 1277192592,
      collectionId: 1295372198,
      artistName: 'Seinfeld',
      collectionName: 'Seinfeld: The Complete Series',
      collectionCensoredName: 'Seinfeld: The Complete Series',
      artistViewUrl:
        'https://itunes.apple.com/us/tv-show/seinfeld/id1277192592?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/tv-season/seinfeld-the-complete-series/id1295372198?uo=4',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/bf/9f/52/bf9f52f5-83ba-a492-9eca-a022e263c68e/source/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Music128/v4/bf/9f/52/bf9f52f5-83ba-a492-9eca-a022e263c68e/source/100x100bb.jpg',
      collectionPrice: 99.99,
      collectionHdPrice: 99.99,
      collectionExplicitness: 'notExplicit',
      contentAdvisoryRating: 'TV-PG',
      trackCount: 171,
      copyright:
        '© 1989- 1998 Castle Rock Entertainment.  All Rights Reserved.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '1989-07-05T07:00:00Z',
      primaryGenreName: 'Comedy',
      longDescription:
        "A stand-up comedian and his three offbeat friends weather the pitfalls and payoffs of life in New York City in the '90s.",
    },
    {
      wrapperType: 'collection',
      collectionType: 'TV Season',
      artistId: 1439181159,
      collectionId: 1446117541,
      artistName: "Marvel's The Punisher",
      collectionName: "Marvel's The Punisher,  Season 1",
      collectionCensoredName: "Marvel's The Punisher,  Season 1",
      artistViewUrl:
        'https://itunes.apple.com/us/tv-show/marvels-the-punisher/id1439181159?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/tv-season/marvels-the-punisher-season-1/id1446117541?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Music128/v4/16/03/57/160357c9-7e6a-e716-109f-f7d47a45d6fb/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Music128/v4/16/03/57/160357c9-7e6a-e716-109f-f7d47a45d6fb/source/100x100bb.jpg',
      collectionPrice: 24.99,
      collectionHdPrice: 29.99,
      collectionExplicitness: 'notExplicit',
      contentAdvisoryRating: 'TV-MA',
      trackCount: 13,
      copyright: '© Marvel & ABC Studios',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2018-12-01T08:00:00Z',
      primaryGenreName: 'Sci-Fi & Fantasy',
      longDescription:
        'Frank Castle, also known as “The Punisher”, believes he has exacted revenge on the criminals responsible for the tragic murder of his family. However, he soon uncovers a larger, deeper conspiracy behind the events that occurred, involving his time serving in the Marine Corps.  Alongside run-ins with law enforcement, his ex-best friend Billy Russo, and former NSA analyst Micro, Frank seeks to uncover the truth once and for all.',
    },
    {
      wrapperType: 'collection',
      collectionType: 'TV Season',
      artistId: 1143715515,
      collectionId: 1143715516,
      artistName: 'The Melancholy of Haruhi Suzumiya',
      collectionName: 'The Melancholy of Haruhi Suzumiya, Seasons 1 & 2',
      collectionCensoredName:
        'The Melancholy of Haruhi Suzumiya, Seasons 1 & 2',
      artistViewUrl:
        'https://itunes.apple.com/us/tv-show/the-melancholy-of-haruhi-suzumiya/id1143715515?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/tv-season/the-melancholy-of-haruhi-suzumiya-seasons-1-2/id1143715516?uo=4',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Music22/v4/f8/6a/93/f86a9368-79fd-9517-39aa-12db0189fb81/source/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Music22/v4/f8/6a/93/f86a9368-79fd-9517-39aa-12db0189fb81/source/100x100bb.jpg',
      collectionPrice: 4.99,
      collectionHdPrice: 4.99,
      collectionExplicitness: 'notExplicit',
      contentAdvisoryRating: 'TV-14',
      trackCount: 28,
      copyright:
        '©2006 Nagaru Tanigawa / Noizi Ito / a member of SOS Licensed by Funimation® Productions, Ltd. All Rights Reserved. ©2007, 2008, 2009 Nagaru Tanigawa · Noizi Ito / a member of SOS Licensed by Funimation® Productions, Ltd. All Rights Reserved.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2006-04-02T08:00:00Z',
      primaryGenreName: 'Animation',
      longDescription:
        'Haruhi Suzumiya dislikes all things ordinary. She’d much rather meet aliens, time-travelers, or ESPers but they’re not exactly showing up at school. And the clubs? So boring! What’s she supposed to do if she can’t keep life interesting? Thanks to the overly curious, Kyon, she’ll set up her own club—The SOS Brigade! She’ll spread her excitement around campus—whether they like it or not.',
    },
    {
      wrapperType: 'collection',
      collectionType: 'TV Season',
      artistId: 1244185052,
      collectionId: 1244185053,
      artistName: 'HYOUKA',
      collectionName: 'HYOUKA, Season 1, Pt. 1',
      collectionCensoredName: 'HYOUKA, Season 1, Pt. 1',
      artistViewUrl:
        'https://itunes.apple.com/us/tv-show/hyouka/id1244185052?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/tv-season/hyouka-season-1-pt-1/id1244185053?uo=4',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Music127/v4/42/26/e2/4226e26b-5743-e0f3-95f9-05d75a557539/source/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Music127/v4/42/26/e2/4226e26b-5743-e0f3-95f9-05d75a557539/source/100x100bb.jpg',
      collectionPrice: 16.99,
      collectionHdPrice: 24.99,
      collectionExplicitness: 'notExplicit',
      contentAdvisoryRating: 'TV-14',
      trackCount: 12,
      copyright:
        '©Honobu Yonezawa · KADOKAWA SHOTEN CO.,LTD.／The graduates of the classic club of the Kamiyama high school Licensed by Funimation® Productions, Ltd. All Rights Reserved.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2012-04-22T07:00:00Z',
      primaryGenreName: 'Animation',
      longDescription:
        'After disenchanted student Hotaro Oreki joins his school’s Classic Lit Club, he meets Eru Chitanda, a kindhearted and inquisitive girl with boundless curiosity and a knack for getting him caught up in all sorts of trouble.',
    },
  ],
  movie: [
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      trackId: 1219320615,
      artistName: 'Mamoru Oshii',
      trackName: 'Ghost In the Shell (25th Anniversary Edition)',
      trackCensoredName: 'Ghost In the Shell (25th Anniversary Edition)',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/ghost-in-the-shell-25th-anniversary-edition/id1219320615?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video124/v4/1b/c6/51/1bc65143-b023-2752-defe-ecbdac6f9b2c/mzvf_15862561121008348391.640x458.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is2-ssl.mzstatic.com/image/thumb/Video114/v4/13/69/a0/1369a0d8-4a72-ef79-f13b-177c97e59d0d/pr_source.lsr/30x30bb.jpg',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Video114/v4/13/69/a0/1369a0d8-4a72-ef79-f13b-177c97e59d0d/pr_source.lsr/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Video114/v4/13/69/a0/1369a0d8-4a72-ef79-f13b-177c97e59d0d/pr_source.lsr/100x100bb.jpg',
      collectionPrice: 4.99,
      trackPrice: 4.99,
      trackRentalPrice: 3.99,
      collectionHdPrice: 4.99,
      trackHdPrice: 4.99,
      trackHdRentalPrice: 3.99,
      releaseDate: '1996-03-29T08:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      trackTimeMillis: 4958175,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Anime',
      contentAdvisoryRating: 'Unrated',
      shortDescription:
        '2029 - A female government cyber agent and the Internal Bureau of Investigations are hot on the',
      longDescription:
        '2029 - A female government cyber agent and the Internal Bureau of Investigations are hot on the trail of a "The Puppet Master" - a computer virus capable of invading cybernetic brains and altering its victim\'s memory.',
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      trackId: 1514516039,
      artistName: 'Makoto Shinkai',
      trackName: 'Weathering With You',
      trackCensoredName: 'Weathering With You',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/weathering-with-you/id1514516039?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video114/v4/fa/f2/40/faf240a7-0e4a-4151-398b-08f56c2ff654/mzvf_12306084848218650148.640x478.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is1-ssl.mzstatic.com/image/thumb/Video114/v4/02/4c/31/024c312d-9e1b-5491-caa5-9665e71f4f90/source/30x30bb.jpg',
      artworkUrl60:
        'https://is1-ssl.mzstatic.com/image/thumb/Video114/v4/02/4c/31/024c312d-9e1b-5491-caa5-9665e71f4f90/source/60x60bb.jpg',
      artworkUrl100:
        'https://is1-ssl.mzstatic.com/image/thumb/Video114/v4/02/4c/31/024c312d-9e1b-5491-caa5-9665e71f4f90/source/100x100bb.jpg',
      collectionPrice: 14.99,
      trackPrice: 14.99,
      trackRentalPrice: 5.99,
      collectionHdPrice: 19.99,
      trackHdPrice: 19.99,
      trackHdRentalPrice: 5.99,
      releaseDate: '2020-01-17T08:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      trackTimeMillis: 6737823,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Sci-Fi & Fantasy',
      contentAdvisoryRating: 'PG-13',
      shortDescription:
        'From Makoto Shinkai, the director of the global smash hit Your Name., comes a critically-acclaimed',
      longDescription:
        'From Makoto Shinkai, the director of the global smash hit Your Name., comes a critically-acclaimed romantic drama set in the rain soaked streets of modern Tokyo. English voice cast includes Alison Brie, Lee Pace and Riz Ahmed.',
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      collectionId: 1484408265,
      trackId: 1462805716,
      artistName: 'Michael Dougherty',
      collectionName:
        'Godzilla: King of the Monsters / Shazam! / Shaft - 3 Film Collection',
      trackName: 'Godzilla: King of the Monsters (2019)',
      collectionCensoredName:
        'Godzilla: King of the Monsters / Shazam! / Shaft - 3 Film Collection',
      trackCensoredName: 'Godzilla: King of the Monsters (2019)',
      collectionArtistId: 199257486,
      collectionArtistViewUrl:
        'https://itunes.apple.com/us/artist/warner-bros-entertainment-inc/199257486?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/movie/godzilla-king-of-the-monsters-2019/id1462805716?uo=4',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/godzilla-king-of-the-monsters-2019/id1462805716?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video123/v4/a5/78/60/a578603f-d985-8c86-baf3-132e37c9a578/mzvf_9034061660384865309.640x352.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is1-ssl.mzstatic.com/image/thumb/Video123/v4/f3/d1/72/f3d172cc-fa7a-0087-1689-a5e3b3ea7073/source/30x30bb.jpg',
      artworkUrl60:
        'https://is1-ssl.mzstatic.com/image/thumb/Video123/v4/f3/d1/72/f3d172cc-fa7a-0087-1689-a5e3b3ea7073/source/60x60bb.jpg',
      artworkUrl100:
        'https://is1-ssl.mzstatic.com/image/thumb/Video123/v4/f3/d1/72/f3d172cc-fa7a-0087-1689-a5e3b3ea7073/source/100x100bb.jpg',
      collectionPrice: 34.99,
      trackPrice: 9.99,
      trackRentalPrice: 0.99,
      collectionHdPrice: 34.99,
      trackHdPrice: 9.99,
      trackHdRentalPrice: 0.99,
      releaseDate: '2019-05-31T07:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      discCount: 1,
      discNumber: 1,
      trackCount: 3,
      trackNumber: 1,
      trackTimeMillis: 7907022,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Action & Adventure',
      contentAdvisoryRating: 'PG-13',
      shortDescription:
        'The story follows the heroic efforts of the crypto-zoological agency Monarch as its members face off',
      longDescription:
        'The story follows the heroic efforts of the crypto-zoological agency Monarch as its members face off against a battery of god-sized monsters, including the mighty Godzilla, who collides with Mothra, Rodan, and his ultimate nemesis, the three-headed King Ghidorah. When these ancient super-species—thought to be mere myths—rise again, they all vie for supremacy, leaving humanity’s very existence hanging in the balance.',
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      collectionId: 1328099012,
      trackId: 270212246,
      artistName: 'James Cameron',
      collectionName: 'Alien Anthology',
      trackName: 'Aliens',
      collectionCensoredName: 'Alien Anthology',
      trackCensoredName: 'Aliens',
      collectionArtistId: 345346894,
      collectionArtistViewUrl:
        'https://itunes.apple.com/us/artist/20th-century-fox-film/345346894?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/movie/aliens/id270212246?uo=4',
      trackViewUrl: 'https://itunes.apple.com/us/movie/aliens/id270212246?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video118/v4/76/f5/a7/76f5a751-cae6-f60f-5bb3-863e98a7aa04/mzvf_2892134214006659570.640x460.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is4-ssl.mzstatic.com/image/thumb/Video49/v4/a9/7e/65/a97e65b4-d1cf-2457-6536-1b2a332f2554/source/30x30bb.jpg',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Video49/v4/a9/7e/65/a97e65b4-d1cf-2457-6536-1b2a332f2554/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Video49/v4/a9/7e/65/a97e65b4-d1cf-2457-6536-1b2a332f2554/source/100x100bb.jpg',
      collectionPrice: 14.99,
      trackPrice: 14.99,
      trackRentalPrice: 3.99,
      collectionHdPrice: 14.99,
      trackHdPrice: 14.99,
      trackHdRentalPrice: 3.99,
      releaseDate: '1986-07-18T07:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      discCount: 1,
      discNumber: 1,
      trackCount: 4,
      trackNumber: 2,
      trackTimeMillis: 8241383,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Sci-Fi & Fantasy',
      contentAdvisoryRating: 'R',
      longDescription:
        'Fifty-seven years after surviving an apocalyptic attack aboard her space vessel by merciless space creatures, Officer Ripley (Sigourney Weaver) awakens from hyper-sleep and tries to warn anyone who will listen about the predators. Although she is ignored at first, when contact with colonists on a planet thought safe is suddenly lost, Ripley and a military team are sent to confront the aliens.',
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      collectionId: 1524375070,
      trackId: 1341054673,
      artistName: 'Alex Garland',
      collectionName: "10 Iconic Films of the 2010's",
      trackName: 'Annihilation',
      collectionCensoredName: "10 Iconic Films of the 2010's",
      trackCensoredName: 'Annihilation',
      collectionArtistId: 1008915738,
      collectionArtistViewUrl:
        'https://itunes.apple.com/us/artist/paramount-home-entertainment-inc/1008915738?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/movie/annihilation/id1341054673?uo=4',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/annihilation/id1341054673?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video122/v4/69/22/da/6922da4d-75a1-30a7-517a-ec4f4cd5983e/mzvf_6298553631306765514.640x354.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is3-ssl.mzstatic.com/image/thumb/Video118/v4/b7/7f/0b/b77f0ba5-77fb-3762-15fa-5ff835c54a62/source/30x30bb.jpg',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Video118/v4/b7/7f/0b/b77f0ba5-77fb-3762-15fa-5ff835c54a62/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Video118/v4/b7/7f/0b/b77f0ba5-77fb-3762-15fa-5ff835c54a62/source/100x100bb.jpg',
      collectionPrice: 9.99,
      trackPrice: 9.99,
      trackRentalPrice: 3.99,
      collectionHdPrice: 14.99,
      trackHdPrice: 14.99,
      trackHdRentalPrice: 3.99,
      releaseDate: '2018-02-23T08:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      discCount: 1,
      discNumber: 1,
      trackCount: 10,
      trackNumber: 3,
      trackTimeMillis: 6934635,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Sci-Fi & Fantasy',
      contentAdvisoryRating: 'R',
      longDescription:
        "From the director of Ex Machina comes one of the year's most critically acclaimed thrillers. Biologist and former soldier Lena (Natalie Portman) is shocked when her missing husband (Oscar Isaac) comes home near death from a top-secret mission into The Shimmer, a mysterious quarantine zone no one has ever returned from. Now, Lena and her elite team must enter a beautiful, deadly world of mutated landscapes and creatures, to discover how to stop the growing phenomenon that threatens all life on Earth. Experience this visually stunning film that will be sure to leave you on the edge of your seat...",
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      collectionId: 1440724736,
      trackId: 1300354540,
      artistName: 'Christopher Nolan',
      collectionName: 'Christopher Nolan – Collection de 8 films',
      trackName: 'Dunkirk (2017)',
      collectionCensoredName: 'Christopher Nolan – Collection de 8 films',
      trackCensoredName: 'Dunkirk (2017)',
      collectionArtistId: 199257486,
      collectionArtistViewUrl:
        'https://itunes.apple.com/us/artist/warner-bros-entertainment-inc/199257486?uo=4',
      collectionViewUrl:
        'https://itunes.apple.com/us/movie/dunkirk-2017/id1300354540?uo=4',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/dunkirk-2017/id1300354540?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video128/v4/8d/bf/0a/8dbf0afa-b25e-cbc7-8fc1-fd99fd957b78/mzvf_8575953190382526243.640x354.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is3-ssl.mzstatic.com/image/thumb/Video118/v4/99/8a/c1/998ac1ab-f00a-5844-d587-1ee5f2fae5f3/source/30x30bb.jpg',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Video118/v4/99/8a/c1/998ac1ab-f00a-5844-d587-1ee5f2fae5f3/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Video118/v4/99/8a/c1/998ac1ab-f00a-5844-d587-1ee5f2fae5f3/source/100x100bb.jpg',
      collectionPrice: 9.99,
      trackPrice: 9.99,
      trackRentalPrice: 3.99,
      collectionHdPrice: 9.99,
      trackHdPrice: 9.99,
      trackHdRentalPrice: 3.99,
      releaseDate: '2017-07-21T07:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      discCount: 1,
      discNumber: 1,
      trackCount: 8,
      trackNumber: 1,
      trackTimeMillis: 6399267,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Action & Adventure',
      contentAdvisoryRating: 'PG-13',
      shortDescription:
        '“Dunkirk” opens as hundreds of thousands of British and Allied troops are surrounded by enemy forces',
      longDescription:
        '“Dunkirk” opens as hundreds of thousands of British and Allied troops are surrounded by enemy forces. Trapped on the beach with their backs to the sea they face an impossible situation as the enemy closes in.',
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      trackId: 1478332956,
      artistName: 'James Gray',
      trackName: 'Ad Astra',
      trackCensoredName: 'Ad Astra',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/ad-astra/id1478332956?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video113/v4/2c/33/2b/2c332bbf-3f71-d258-676f-ad1e0fe57e13/mzvf_10267843861024657833.640x354.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is3-ssl.mzstatic.com/image/thumb/Video123/v4/b8/25/f4/b825f4c3-a25f-11e9-95c7-759a04dc9315/pr_source.lsr/30x30bb.jpg',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Video123/v4/b8/25/f4/b825f4c3-a25f-11e9-95c7-759a04dc9315/pr_source.lsr/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Video123/v4/b8/25/f4/b825f4c3-a25f-11e9-95c7-759a04dc9315/pr_source.lsr/100x100bb.jpg',
      collectionPrice: 9.99,
      trackPrice: 9.99,
      collectionHdPrice: 9.99,
      trackHdPrice: 9.99,
      releaseDate: '2019-09-20T07:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      trackTimeMillis: 7421203,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Action & Adventure',
      contentAdvisoryRating: 'PG-13',
      shortDescription:
        'Astronaut Roy McBride (Brad Pitt) travels to the outer edges of the solar system to find his missing',
      longDescription:
        'Astronaut Roy McBride (Brad Pitt) travels to the outer edges of the solar system to find his missing father and unravel a mystery that threatens the survival of our planet. His journey will uncover secrets that challenge the nature of human existence and our place in the cosmos.Astronaut Roy McBride (Brad Pitt) travels to the outer edges of the solar system to find his missing father and unravel a mystery that threatens the survival of our planet. His journey will uncover secrets that challenge the nature of human existence and our place in the cosmos.',
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      trackId: 1490807532,
      artistName: 'Sam Mendes',
      trackName: '1917',
      trackCensoredName: '1917',
      trackViewUrl: 'https://itunes.apple.com/us/movie/1917/id1490807532?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video123/v4/31/74/86/3174866f-728c-86f5-ec6d-ea88db4948dc/mzvf_14499559803575023981.640x356.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is4-ssl.mzstatic.com/image/thumb/Video114/v4/ce/4a/7e/ce4a7edb-6935-92e0-2561-12444cf79a85/pr_source.lsr/30x30bb.jpg',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Video114/v4/ce/4a/7e/ce4a7edb-6935-92e0-2561-12444cf79a85/pr_source.lsr/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Video114/v4/ce/4a/7e/ce4a7edb-6935-92e0-2561-12444cf79a85/pr_source.lsr/100x100bb.jpg',
      collectionPrice: 19.99,
      trackPrice: 19.99,
      trackRentalPrice: 5.99,
      collectionHdPrice: 19.99,
      trackHdPrice: 19.99,
      trackHdRentalPrice: 5.99,
      releaseDate: '2019-12-25T08:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      trackTimeMillis: 7138623,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Drama',
      contentAdvisoryRating: 'R',
      shortDescription:
        'Sam Mendes, the Oscar®-winning director of Skyfall, Spectre and American Beauty, brings his singular',
      longDescription:
        "Sam Mendes, the Oscar®-winning director of Skyfall, Spectre and American Beauty, brings his singular vision to this World War I epic. At the height of the First World War, two young British soldiers, Schofield (Captain Fantastic’s George MacKay) and Blake (Game of Thrones' Dean-Charles Chapman) are given a seemingly impossible mission. In a race against time, they must cross enemy territory and deliver a message that will stop a deadly attack on hundreds of soldiers—Blake's own brother among them.",
      hasITunesExtras: true,
    },
    {
      wrapperType: 'track',
      kind: 'feature-movie',
      trackId: 1042745581,
      artistName: 'Danny Boyle',
      trackName: 'Steve Jobs (2015)',
      trackCensoredName: 'Steve Jobs (2015)',
      trackViewUrl:
        'https://itunes.apple.com/us/movie/steve-jobs-2015/id1042745581?uo=4',
      previewUrl:
        'https://video-ssl.itunes.apple.com/itunes-assets/Video118/v4/6a/8b/6c/6a8b6cf0-fddb-a8d7-608c-b116a995db97/mzvf_2252982505696631856.640x362.h264lc.U.p.m4v',
      artworkUrl30:
        'https://is3-ssl.mzstatic.com/image/thumb/Video69/v4/74/88/20/7488203e-ba32-6f9f-5410-cc084edfa560/source/30x30bb.jpg',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Video69/v4/74/88/20/7488203e-ba32-6f9f-5410-cc084edfa560/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Video69/v4/74/88/20/7488203e-ba32-6f9f-5410-cc084edfa560/source/100x100bb.jpg',
      collectionPrice: 14.99,
      trackPrice: 14.99,
      trackRentalPrice: 3.99,
      collectionHdPrice: 14.99,
      trackHdPrice: 14.99,
      trackHdRentalPrice: 3.99,
      releaseDate: '2015-10-09T07:00:00Z',
      collectionExplicitness: 'notExplicit',
      trackExplicitness: 'notExplicit',
      trackTimeMillis: 7336000,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Drama',
      contentAdvisoryRating: 'R',
      shortDescription:
        'Set backstage at three iconic product launches and ending in 1998 with the unveiling of the iMac,',
      longDescription:
        'Witness the founder of Apple like never before. Steve Jobs paints an intimate portrait of the brilliant man at the epicenter of the digital revolution, backstage in the final minutes before three iconic product launches. Directed by Academy Award® winner Danny Boyle (Slumdog Millionaire), written by Academy Award® winner Aaron Sorkin (The Social Network) and starring Michael Fassbender, Kate Winslet, Seth Rogen and Jeff Daniels.',
      hasITunesExtras: true,
    },
  ],
  album: [
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 148662,
      collectionId: 1204427627,
      amgArtistId: 447095,
      artistName: 'LINKIN PARK',
      collectionName: 'One More Light',
      collectionCensoredName: 'One More Light',
      artistViewUrl:
        'https://music.apple.com/us/artist/linkin-park/148662?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/one-more-light/1204427627?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Music122/v4/50/89/c3/5089c3f8-ed7c-cdeb-fe3b-2931deee3a98/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Music122/v4/50/89/c3/5089c3f8-ed7c-cdeb-fe3b-2931deee3a98/source/100x100bb.jpg',
      collectionPrice: 4.99,
      collectionExplicitness: 'explicit',
      contentAdvisoryRating: 'Explicit',
      trackCount: 10,
      copyright: '℗ 2017 Warner Records Inc.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2017-05-19T07:00:00Z',
      primaryGenreName: 'Alternative',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 1449555775,
      collectionId: 1449555773,
      artistName: 'Minami',
      collectionName: 'Kawakiwoameku - EP',
      collectionCensoredName: 'Kawakiwoameku - EP',
      artistViewUrl: 'https://music.apple.com/us/artist/minami/1449555775?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/kawakiwoameku-ep/1449555773?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Music114/v4/a6/e7/bf/a6e7bfce-bc49-ebd8-adce-26a8e12029fb/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Music114/v4/a6/e7/bf/a6e7bfce-bc49-ebd8-adce-26a8e12029fb/source/100x100bb.jpg',
      collectionPrice: 6.45,
      collectionExplicitness: 'notExplicit',
      trackCount: 5,
      copyright: '℗ Victor Entertainment',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2019-01-30T08:00:00Z',
      primaryGenreName: 'Anime',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 1490256993,
      collectionId: 1528119626,
      artistName: 'YOASOBI',
      collectionName: '群青 - Single',
      collectionCensoredName: '群青 - Single',
      artistViewUrl:
        'https://music.apple.com/us/artist/yoasobi/1490256993?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/%E7%BE%A4%E9%9D%92-single/1528119626?uo=4',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Music124/v4/9b/81/84/9b8184fa-18c0-a83d-b099-62ff343dd608/source/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Music124/v4/9b/81/84/9b8184fa-18c0-a83d-b099-62ff343dd608/source/100x100bb.jpg',
      collectionPrice: 1.29,
      collectionExplicitness: 'notExplicit',
      trackCount: 1,
      copyright: '℗ 2020 YOASOBI',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2020-09-01T07:00:00Z',
      primaryGenreName: 'J-Pop',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 148662,
      collectionId: 873395041,
      amgArtistId: 447095,
      artistName: 'LINKIN PARK',
      collectionName: 'The Hunting Party',
      collectionCensoredName: 'The Hunting Party',
      artistViewUrl:
        'https://music.apple.com/us/artist/linkin-park/148662?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/the-hunting-party/873395041?uo=4',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Music/v4/58/c8/38/58c83839-9eb5-80c2-bf60-68fb824e0873/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Music/v4/58/c8/38/58c83839-9eb5-80c2-bf60-68fb824e0873/source/100x100bb.jpg',
      collectionPrice: 10.99,
      collectionExplicitness: 'explicit',
      contentAdvisoryRating: 'Explicit',
      trackCount: 12,
      copyright: '℗ 2014 Warner Records Inc.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2014-06-13T07:00:00Z',
      primaryGenreName: 'Hard Rock',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 41334108,
      collectionId: 1386840228,
      amgArtistId: 388572,
      artistName: 'Mike Shinoda',
      collectionName: 'Post Traumatic',
      collectionCensoredName: 'Post Traumatic',
      artistViewUrl:
        'https://music.apple.com/us/artist/mike-shinoda/41334108?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/post-traumatic/1386840228?uo=4',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Music115/v4/08/c8/5c/08c85cfa-1a30-a301-48b8-c5e79cd3ca3c/source/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Music115/v4/08/c8/5c/08c85cfa-1a30-a301-48b8-c5e79cd3ca3c/source/100x100bb.jpg',
      collectionPrice: 9.99,
      collectionExplicitness: 'cleaned',
      contentAdvisoryRating: 'Clean',
      trackCount: 16,
      copyright: '℗ 2018 Warner Records Inc.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2018-06-15T07:00:00Z',
      primaryGenreName: 'Alternative',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 947171999,
      collectionId: 1457598076,
      artistName: 'AURORA',
      collectionName: 'A Different Kind of Human (Step II)',
      collectionCensoredName: 'A Different Kind of Human (Step II)',
      artistViewUrl: 'https://music.apple.com/us/artist/aurora/947171999?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/a-different-kind-of-human-step-ii/1457598076?uo=4',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Music113/v4/88/40/ae/8840ae2d-5ad6-4b6d-9147-593b92b35977/source/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Music113/v4/88/40/ae/8840ae2d-5ad6-4b6d-9147-593b92b35977/source/100x100bb.jpg',
      collectionPrice: 7.99,
      collectionExplicitness: 'notExplicit',
      trackCount: 11,
      copyright:
        '℗ 2019 Glassnote Entertainment Group LLC, distributed by AWAL',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2019-06-07T07:00:00Z',
      primaryGenreName: 'Pop',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 376334342,
      collectionId: 950516608,
      artistName: '日本アニメ(ーター)見本市/TeddyLoid/daoko',
      collectionName: '日本アニメ(ーター)見本市 「ME!ME!ME!」 - Single',
      collectionCensoredName: '日本アニメ(ーター)見本市 「ME!ME!ME!」 - Single',
      artistViewUrl:
        'https://music.apple.com/us/artist/teddyloid/376334342?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/%E6%97%A5%E6%9C%AC%E3%82%A2%E3%83%8B%E3%83%A1-%E3%83%BC%E3%82%BF%E3%83%BC-%E8%A6%8B%E6%9C%AC%E5%B8%82-me-me-me-single/950516608?uo=4',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Music1/v4/3c/ba/1f/3cba1fc3-883c-050f-b2ab-864cc2d585d2/source/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Music1/v4/3c/ba/1f/3cba1fc3-883c-050f-b2ab-864cc2d585d2/source/100x100bb.jpg',
      collectionExplicitness: 'notExplicit',
      trackCount: 3,
      copyright: '℗ 2014 King Record Co.,Ltd.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2014-12-22T08:00:00Z',
      primaryGenreName: 'Anime',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 1081292904,
      collectionId: 1504054810,
      amgArtistId: 3336108,
      artistName: 'the peggies',
      collectionName: 'Anemone EP',
      collectionCensoredName: 'Anemone EP',
      artistViewUrl:
        'https://music.apple.com/us/artist/the-peggies/1081292904?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/anemone-ep/1504054810?uo=4',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Music113/v4/1b/63/80/1b638007-4907-6b17-c691-f015a0a515ed/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Music113/v4/1b/63/80/1b638007-4907-6b17-c691-f015a0a515ed/source/100x100bb.jpg',
      collectionPrice: 5.99,
      collectionExplicitness: 'notExplicit',
      trackCount: 5,
      copyright: '℗ 2020 Sony Music Labels Inc.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2020-04-08T07:00:00Z',
      primaryGenreName: 'J-Pop',
    },
    {
      wrapperType: 'collection',
      collectionType: 'Album',
      artistId: 614405787,
      collectionId: 1498210803,
      artistName: 'Mafumafu',
      collectionName: 'Sore Wo Ai To Yobudake - Single',
      collectionCensoredName: 'Sore Wo Ai To Yobudake - Single',
      artistViewUrl:
        'https://music.apple.com/us/artist/mafumafu/614405787?uo=4',
      collectionViewUrl:
        'https://music.apple.com/us/album/sore-wo-ai-to-yobudake-single/1498210803?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Music123/v4/11/fa/7b/11fa7b48-cf32-01da-a38a-e88877e1ce6a/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Music123/v4/11/fa/7b/11fa7b48-cf32-01da-a38a-e88877e1ce6a/source/100x100bb.jpg',
      collectionPrice: 1.29,
      collectionExplicitness: 'notExplicit',
      trackCount: 1,
      copyright: '℗ 2020 A-Sketch Inc.',
      country: 'USA',
      currency: 'USD',
      releaseDate: '2020-02-21T08:00:00Z',
      primaryGenreName: 'J-Pop',
    },
  ],
  ebook: [
    {
      fileSizeBytes: 2667284,
      formattedPrice: '$9.99',
      releaseDate: '1983-10-17T07:00:00Z',
      trackId: 427503546,
      trackName: '1984',
      genreIds: ['10042', '38', '9031', '10049'],
      artistIds: [2632114],
      trackCensoredName: '1984',
      artistViewUrl:
        'https://books.apple.com/us/artist/george-orwell/2632114?uo=4',
      trackViewUrl: 'https://books.apple.com/us/book/1984/id427503546?uo=4',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Publication118/v4/ad/8d/74/ad8d7436-a09b-5c7e-829f-a59ec4501e05/source/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Publication118/v4/ad/8d/74/ad8d7436-a09b-5c7e-829f-a59ec4501e05/source/100x100bb.jpg',
      currency: 'USD',
      price: 9.99,
      artistId: 2632114,
      artistName: 'George Orwell',
      genres: ['Classics', 'Books', 'Fiction & Literature', 'Literary'],
      description:
        '<b>A PBS Great American Read Top 100 Pick</b><br /><br /> With extraordinary relevance and renewed popularity, George Orwell’s <i>1984</i> takes on new life in this edition.<br /><br /> “Orwell saw, to his credit, that the act of falsifying reality is only secondarily a way of changing perceptions. It is, above all, a way of asserting power.”—The New Yorker<br /> &#xa0;<br /> In <i>1984</i>, London is a grim city in the totalitarian state of Oceania where Big Brother is always watching you and the Thought Police can practically read your mind. Winston Smith is a man in grave danger for the simple reason that his memory still functions. Drawn into a forbidden love affair, Winston finds the courage to join a secret revolutionary organization called The Brotherhood, dedicated to the destruction of the Party. Together with his beloved Julia, he hazards his life in a deadly match against the powers that be.<br /><br /> Lionel Trilling said of Orwell’s masterpiece, “<i>1984</i> is a profound, terrifying, and wholly fascinating book. It is a fantasy of the political future, and like any such fantasy, serves its author as a magnifying device for an examination of the present.” Though the year 1984 now exists in the past, Orwell’s novel remains an urgent call for the individual willing to speak truth to power.',
      kind: 'ebook',
      averageUserRating: 4.5,
      userRatingCount: 1884,
    },
    {
      fileSizeBytes: 5719942,
      formattedPrice: '$12.99',
      releaseDate: '2003-05-27T07:00:00Z',
      trackId: 381724898,
      trackName: 'The Great Gatsby',
      genreIds: ['10042', '38', '9031', '10049'],
      artistIds: [2037135],
      trackCensoredName: 'The Great Gatsby',
      artistViewUrl:
        'https://books.apple.com/us/artist/f-scott-fitzgerald/2037135?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/the-great-gatsby/id381724898?uo=4',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Publication123/v4/1c/64/da/1c64dabb-a200-3c65-2c66-adb2d475f326/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Publication123/v4/1c/64/da/1c64dabb-a200-3c65-2c66-adb2d475f326/source/100x100bb.jpg',
      currency: 'USD',
      price: 12.99,
      artistId: 2037135,
      artistName: 'F. Scott Fitzgerald',
      genres: ['Classics', 'Books', 'Fiction & Literature', 'Literary'],
      description:
        '<b>A true classic of twentieth-century literature, this edition has been updated by Fitzgerald scholar James L.W. West III to include the author’s final revisions and features a note on the composition and text, a personal foreword by Fitzgerald’s granddaughter, Eleanor Lanahan—and a new introduction by two-time National Book Award winner Jesmyn Ward.</b><br /><br /><b>Nominated as one of America’s best-loved novels by PBS’s <i>The Great American Read.</i></b><br /><br /><i>The Great Gatsby</i>, F. Scott Fitzgerald’s third book, stands as the supreme achievement of his career. First published in 1925, this quintessential novel of the Jazz Age has been acclaimed by generations of readers. The story of the mysteriously wealthy Jay Gatsby and his love for the beautiful Daisy Buchanan, of lavish parties on Long Island at a time when <i>The New York Times</i> noted “gin was the national drink and sex the national obsession,” it is an exquisitely crafted tale of America in the 1920s.',
      kind: 'ebook',
      averageUserRating: 4.5,
      userRatingCount: 5319,
    },
    {
      fileSizeBytes: 8305445,
      formattedPrice: '$8.99',
      releaseDate: '1988-09-12T07:00:00Z',
      trackId: 420462817,
      trackName: 'The Queen of the Damned',
      genreIds: ['10044', '38', '9020', '9031'],
      artistIds: [2007200],
      trackCensoredName: 'The Queen of the Damned',
      artistViewUrl: 'https://books.apple.com/us/artist/anne-rice/2007200?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/the-queen-of-the-damned/id420462817?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Publication4/v4/95/f9/47/95f947da-ee3b-d675-f063-8518199acf72/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Publication4/v4/95/f9/47/95f947da-ee3b-d675-f063-8518199acf72/source/100x100bb.jpg',
      currency: 'USD',
      price: 8.99,
      artistId: 2007200,
      artistName: 'Anne Rice',
      genres: ['Fantasy', 'Books', 'Sci-Fi & Fantasy', 'Fiction & Literature'],
      description:
        'In a feat of virtuoso storytelling, Anne Rice unleashes Akasha, the queen of the damned, who has risen from a six-thousand-year sleep to let loose the powers of the night. Akasha has a marvelously devious plan to “save” mankind and destroy the vampire Lestat—in this extraordinarily sensual novel of the complex, erotic, electrifying world of the undead.<br /><br /><b>Look for a special preview of Anne Rice’s&#xa0;<i>Prince Lestat</i>&#xa0;in the back of the book.&#xa0;The Vampire Chronicles continue in&#xa0;<i>Prince Lestat and&#xa0;the Realms of Atlantis,&#xa0;</i>available for pre-order now.</b><br /><br /><b>Praise for <i>The Queen of the Damned</i></b><br /><br />“Mesmerizing . . . a wonderful web of dark-side mythology.”<b>—<i>San Francisco Chronicle</i></b><br /> &#xa0;<br /> “With <i>The Queen of the Damned,</i> Anne Rice has created universes within universes, traveling back in time as far as ancient, pre-pyramidic Egypt and journeying from the frozen mountain peaks of Nepal to the crowded, sweating streets of southern Florida.”<b>—<i>Los Angeles Times</i></b><br /> &#xa0;<br /> “Imaginative . . . intelligently written . . . This is popular fiction of the highest order.”<b>—<i>USA Today</i></b><br /> &#xa0;<br /> “A tour de force.”<b><i>—The Boston Globe</i>&#xa0;</b>',
      kind: 'ebook',
      averageUserRating: 4.5,
      userRatingCount: 107,
    },
    {
      fileSizeBytes: 504548,
      formattedPrice: 'Free',
      releaseDate: '2008-06-09T07:00:00Z',
      trackId: 765107106,
      trackName: 'The Picture of Dorian Gray',
      genreIds: ['9031', '38'],
      artistIds: [2765844],
      trackCensoredName: 'The Picture of Dorian Gray',
      artistViewUrl:
        'https://books.apple.com/us/artist/oscar-wilde/2765844?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/the-picture-of-dorian-gray/id765107106?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Publication6/v4/b2/27/52/b22752d8-ca04-e8e7-ed60-8a6b52855dc3/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Publication6/v4/b2/27/52/b22752d8-ca04-e8e7-ed60-8a6b52855dc3/source/100x100bb.jpg',
      currency: 'USD',
      price: 0.0,
      artistId: 2765844,
      artistName: 'Oscar Wilde',
      genres: ['Fiction & Literature', 'Books'],
      description:
        "The Picture of Dorian Gray is the only published novel by Oscar Wilde, appearing as the lead story in Lippincott's Monthly Magazine on 20 June 1890, printed as the July 1890 issue of this magazine. The magazine's editors feared the story was indecent as submitted, so they censored roughly 500 words, without Wilde's knowledge, before publication. But even with that, the story was still greeted with outrage by British reviewers, some of whom suggested that Wilde should be prosecuted on moral grounds, leading Wilde to defend the novel aggressively in letters to the British press. Wilde later revised the story for book publication, making substantial alterations, deleting controversial passages, adding new chapters and including an aphoristic Preface which has since become famous in its own right. The amended version was published by Ward, Lock and Company in April 1891. Some scholars believe that Wilde would today have wanted us to read the version he originally submitted to Lippincott's.",
      kind: 'ebook',
      averageUserRating: 4.5,
      userRatingCount: 133,
    },
    {
      fileSizeBytes: 6133731,
      formattedPrice: '$0.99',
      releaseDate: '2013-08-26T07:00:00Z',
      trackId: 673581115,
      trackName: 'The Raven',
      genreIds: ['10042', '38', '9031', '10093', '10049'],
      artistIds: [2066399],
      trackCensoredName: 'The Raven',
      artistViewUrl:
        'https://books.apple.com/us/artist/edgar-allan-poe/2066399?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/the-raven/id673581115?uo=4',
      artworkUrl60:
        'https://is1-ssl.mzstatic.com/image/thumb/Publication118/v4/7c/03/16/7c0316c2-2e0f-a00a-ced4-91a0675c5b85/source/60x60bb.jpg',
      artworkUrl100:
        'https://is1-ssl.mzstatic.com/image/thumb/Publication118/v4/7c/03/16/7c0316c2-2e0f-a00a-ced4-91a0675c5b85/source/100x100bb.jpg',
      currency: 'USD',
      price: 0.99,
      artistId: 2066399,
      artistName: 'Edgar Allan Poe',
      genres: [
        'Classics',
        'Books',
        'Fiction & Literature',
        'Poetry',
        'Literary',
      ],
      description:
        'Edgar Allan Poe’s celebrated narrative poem now available as an ebook, including an extended excerpt from <i>Mrs. Poe </i>by Lynn Cullen, a vivid and compelling novel about a poet who becomes entangled in an affair with Edgar Allan Poe—at the same time that she becomes the unwilling confidante of his much-younger wife.',
      kind: 'ebook',
      averageUserRating: 4.0,
      userRatingCount: 108,
    },
    {
      fileSizeBytes: 2162540,
      formattedPrice: '$4.99',
      releaseDate: '2013-07-09T07:00:00Z',
      trackId: 710523293,
      trackName: 'Frankenstein',
      genreIds: ['10042', '38', '9031'],
      artistIds: [677955784],
      trackCensoredName: 'Frankenstein',
      artistViewUrl:
        'https://books.apple.com/us/artist/mary-shelly/677955784?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/frankenstein/id710523293?uo=4',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Publication4/v4/45/c6/f7/45c6f74a-b729-eb4f-759c-5f9b31f8cca0/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Publication4/v4/45/c6/f7/45c6f74a-b729-eb4f-759c-5f9b31f8cca0/source/100x100bb.jpg',
      currency: 'USD',
      price: 4.99,
      artistId: 677955784,
      artistName: 'Mary Shelly',
      genres: ['Classics', 'Books', 'Fiction & Literature'],
      description:
        'Postać Frankensteina znają chyba wszyscy. Potwór siejący grozę i spustoszenie na stałe zadomowił się w kulturze światowej. Do zbiorowej świadomości trafił on jednak nie z książki, ale z licznych filmów jemu poświęconych. Mało kto zdaje sobie sprawę, jak bardzo kino zniekształciło pierwowzór. Dzisiaj dajemy Czytelnikowi szansę zapoznania się z oryginalną wersją historii o Wiktorze Frankensteinie i jego dziele. Historii o zgubnej ambicji, o odpowiedzialności za swe czyny, o odtrąceniu i samotności, o krzywdzie i zemście. Klasyczną powieść Mary Shelley oddajemy do rąk Czytelników w nowym przekładzie Pawła Łopatki.',
      kind: 'ebook',
    },
    {
      fileSizeBytes: 1645147,
      formattedPrice: '$9.99',
      releaseDate: '1959-11-05T08:00:00Z',
      trackId: 407581409,
      trackName: 'Starship Troopers',
      genreIds: ['11006', '38', '9020', '10064', '10063'],
      artistIds: [2038596],
      trackCensoredName: 'Starship Troopers',
      artistViewUrl:
        'https://books.apple.com/us/artist/robert-a-heinlein/2038596?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/starship-troopers/id407581409?uo=4',
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Publication125/v4/cd/3a/3d/cd3a3df0-a5f5-8a3e-9051-f0487b083804/source/60x60bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Publication125/v4/cd/3a/3d/cd3a3df0-a5f5-8a3e-9051-f0487b083804/source/100x100bb.jpg',
      currency: 'USD',
      price: 9.99,
      artistId: 2038596,
      artistName: 'Robert A. Heinlein',
      genres: [
        'Adventure',
        'Books',
        'Sci-Fi & Fantasy',
        'Science Fiction & Literature',
        'Science Fiction',
      ],
      description:
        '<b>In Robert A. Heinlein’s controversial Hugo Award-winning bestseller, a recruit of the future goes through the toughest boot camp in the Universe—and into battle against mankind’s most alarming enemy...</b><br /><br />Johnnie Rico never really intended to join up—and definitely not the infantry. But now that he’s in the thick of it, trying to get through combat training harder than anything he could have imagined, he knows everyone in his unit is one bad move away from buying the farm in the interstellar war the Terran Federation is waging against the Arachnids.<br /><br />Because everyone in the Mobile Infantry fights. And if the training doesn’t kill you, the Bugs are more than ready to finish the job...<br /><br /><b>“A classic…If you want a great military adventure, this one is for you.”—</b><i><b>All SciFi</b></i>',
      kind: 'ebook',
      averageUserRating: 4.5,
      userRatingCount: 1022,
    },
    {
      fileSizeBytes: 5606870,
      formattedPrice: '$0.99',
      releaseDate: '2018-11-14T08:00:00Z',
      trackId: 1442918408,
      trackName: 'The Complete Poetry of Percy Bysshe Shelley',
      genreIds: ['10093', '38', '9031'],
      artistIds: [104950187],
      trackCensoredName: 'The Complete Poetry of Percy Bysshe Shelley',
      artistViewUrl:
        'https://books.apple.com/us/artist/percy-bysshe-shelley/104950187?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/the-complete-poetry-of-percy-bysshe-shelley/id1442918408?uo=4',
      artworkUrl60:
        'https://is1-ssl.mzstatic.com/image/thumb/Publication128/v4/43/0b/63/430b63a5-3f32-9c54-bd57-bade2244ba5e/source/60x60bb.jpg',
      artworkUrl100:
        'https://is1-ssl.mzstatic.com/image/thumb/Publication128/v4/43/0b/63/430b63a5-3f32-9c54-bd57-bade2244ba5e/source/100x100bb.jpg',
      currency: 'USD',
      price: 0.99,
      artistId: 104950187,
      artistName: 'Percy Bysshe Shelley',
      genres: ['Poetry', 'Books', 'Fiction & Literature'],
      description:
        'This carefully crafted ebook collection is formatted for your eReader with a functional and detailed table of contents:<br/>\nThe Daemon of the World<br/>\nAlastor: or, the Spirit of Solitude.<br/>\nThe Revolt of Islam<br/>\nPrince Athanase<br/>\nRosalind and Helen<br/>\nJulian and Maddalo<br/>\nPrometheus Unbound<br/>\nThe Cenci – A Tragedy in Five Acts<br/>\nThe Mask of Anarchy<br/>\nPeter Bell the Third<br/>\nLetter to Maria Gisborne<br/>\nThe Witch of Atlas<br/>\nOedipus Tyrannus<br/>\nEpipsychidion<br/>\nAdonais<br/>\nHellas<br/>\nFragments of an Unfinished Drama<br/>\nCharles the First<br/>\nThe Triumph of Life<br/>\nEarly Poems (1814, 1815):<br/>\nStanza, Written at Bracknell<br/>\nStanzas — April, 1814<br/>\nTo Harriet<br/>\nTo Mary Wollstonecraft Godwin<br/>\nMutability<br/>\nOn Death<br/>\nA Summer Evening Churchyard<br/>\nTo Wordsworth<br/>\nFeelings of a Republican on the Fall of Bonaparte<br/>\nLines…<br/>\nPoems Written in 1816-1822:<br/>\nThe Sunset<br/>\nHymn to Intellectual Beauty<br/>\nMont Blanc<br/>\nHome<br/>\nFragment of a Ghost Story<br/>\nMarianne&#39;s Dream<br/>\nTo Constantia, Singing<br/>\nTo Constantia<br/>\nTo Music<br/>\n&#39;Mighty Eagle&#39;<br/>\nTo William Shelley<br/>\nOn Fanny Godwin<br/>\nDeath<br/>\nOtho<br/>\nA Hate-Song<br/>\nLines to a Critic<br/>\nOzymandias<br/>\nTo the Nile<br/>\nPassage of the Apennines<br/>\nThe Past<br/>\nTo Mary<br/>\nOn a Faded Violet<br/>\nOctober, 1818<br/>\nSong for &#39;Tasso&#39;<br/>\nInvocation to Misery<br/>\nThe Woodman and the Nightingale<br/>\nMarenghi<br/>\nSonnet<br/>\nTo Byron<br/>\nApostrophe to Silence<br/>\nThe Lake&#39;s Margin<br/>\nThe Vine-Shroud<br/>\nSong to the Men of England<br/>\nTo the People of England<br/>\n&#39;What Men Gain Fairly&#39;<br/>\nA New National Anthem<br/>\nOde to Heaven<br/>\nOde to the West Wind<br/>\nAn Exhortation<br/>\nLove&#39;s Philosophy<br/>\nThe Birth of Pleasure<br/>\nRain<br/>\nA Tale Untold<br/>\nTo Italy<br/>\nWine of the Fairies<br/>\nA Roman&#39;s Chamber<br/>\nRome and Nature<br/>\nThe Sensitive Plant<br/>\nA Vision of the Sea<br/>\nThe Cloud<br/>\nTo a Skylark<br/>\nOde to Liberty<br/>\nDirge for the Year<br/>\nTo Night<br/>\nTime<br/>\nThe Fugitives<br/>\nThe Zucca<br/>\nThe Isle…<br/>\nTranslations:<br/>\nHymn to Mercury<br/>\nHomer&#39;s Hymns<br/>\nThe Cyclops<br/>\nEpigrams from the Greek<br/>\nPan, Echo, and the Satyr<br/>\nUgolino….<br/>\nJuvenilia:<br/>\nQueen Mab<br/>\nVerses on a Cat<br/>\nOmens<br/>\nEpitaphium<br/>\nIn Horologium<br/>\nTo the Moonbeam<br/>\nThe Solitary<br/>\nLove&#39;s Ros',
      kind: 'ebook',
    },
    {
      fileSizeBytes: 8914657,
      formattedPrice: '$9.99',
      releaseDate: '2012-01-24T08:00:00Z',
      trackId: 427696948,
      trackName: 'The Man in the High Castle',
      genreIds: ['9020', '38', '9031', '10049'],
      artistIds: [2125672],
      trackCensoredName: 'The Man in the High Castle',
      artistViewUrl:
        'https://books.apple.com/us/artist/philip-k-dick/2125672?uo=4',
      trackViewUrl:
        'https://books.apple.com/us/book/the-man-in-the-high-castle/id427696948?uo=4',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Publication122/v4/2d/f2/0e/2df20ee2-082c-c89a-d8ac-4c717dd4e30c/source/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Publication122/v4/2d/f2/0e/2df20ee2-082c-c89a-d8ac-4c717dd4e30c/source/100x100bb.jpg',
      currency: 'USD',
      price: 9.99,
      artistId: 2125672,
      artistName: 'Philip K. Dick',
      genres: ['Sci-Fi & Fantasy', 'Books', 'Fiction & Literature', 'Literary'],
      description:
        "It's America in 1962. Slavery is legal once again. The few Jews who still survive hide under assumed names. In San Francisco, the I Ching is as common as the Yellow Pages. All because some 20 years earlier the United States lost a war—and is now occupied by Nazi Germany and Japan.<br /><br />  This harrowing, Hugo Award-winning novel is the work that established Philip K. Dick as an innovator in science fiction while breaking the barrier between science fiction and the serious novel of ideas. In it Dick offers a haunting vision of history as a nightmare from which it may just be possible to wake.",
      kind: 'ebook',
      averageUserRating: 4.0,
      userRatingCount: 676,
    },
  ],
  podcast: [
    {
      wrapperType: 'track',
      kind: 'podcast',
      artistId: 1456044916,
      collectionId: 1338558972,
      trackId: 1338558972,
      artistName: 'Stakhanov',
      collectionName: 'Abroad in Japan',
      trackName: 'Abroad in Japan',
      collectionCensoredName: 'Abroad in Japan',
      trackCensoredName: 'Abroad in Japan',
      artistViewUrl:
        'https://podcasts.apple.com/us/artist/stakhanov/1456044916?uo=4',
      collectionViewUrl:
        'https://podcasts.apple.com/us/podcast/abroad-in-japan/id1338558972?uo=4',
      feedUrl: 'https://rss.acast.com/abroadinjapan',
      trackViewUrl:
        'https://podcasts.apple.com/us/podcast/abroad-in-japan/id1338558972?uo=4',
      artworkUrl30:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/5d/bd/7b/5dbd7b23-7835-2f14-ebbd-a81bfecba6a8/mza_9091213752577291935.jpg/30x30bb.jpg',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/5d/bd/7b/5dbd7b23-7835-2f14-ebbd-a81bfecba6a8/mza_9091213752577291935.jpg/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/5d/bd/7b/5dbd7b23-7835-2f14-ebbd-a81bfecba6a8/mza_9091213752577291935.jpg/100x100bb.jpg',
      collectionPrice: 0.0,
      trackPrice: 0.0,
      trackRentalPrice: 0,
      collectionHdPrice: 0,
      trackHdPrice: 0,
      trackHdRentalPrice: 0,
      releaseDate: '2020-09-13T21:00:00Z',
      collectionExplicitness: 'cleaned',
      trackExplicitness: 'cleaned',
      trackCount: 145,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Places & Travel',
      contentAdvisoryRating: 'Clean',
      artworkUrl600:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/5d/bd/7b/5dbd7b23-7835-2f14-ebbd-a81bfecba6a8/mza_9091213752577291935.jpg/600x600bb.jpg',
      genreIds: ['1320', '26', '1324'],
      genres: ['Places & Travel', 'Podcasts', 'Society & Culture'],
    },
    {
      wrapperType: 'track',
      kind: 'podcast',
      artistId: 204647080,
      collectionId: 118678606,
      trackId: 118678606,
      artistName: 'IGN',
      collectionName: 'The IGN Movies Show',
      trackName: 'The IGN Movies Show',
      collectionCensoredName: 'The IGN Movies Show',
      trackCensoredName: 'The IGN Movies Show',
      artistViewUrl: 'https://podcasts.apple.com/us/artist/ign/204647080?uo=4',
      collectionViewUrl:
        'https://podcasts.apple.com/us/podcast/the-ign-movies-show/id118678606?uo=4',
      feedUrl: 'http://feeds.feedburner.com/ignfeeds/podcasts/movies',
      trackViewUrl:
        'https://podcasts.apple.com/us/podcast/the-ign-movies-show/id118678606?uo=4',
      artworkUrl30:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts123/v4/d1/58/f4/d158f4b6-e96f-a2ca-e218-2232127bd6fa/mza_1742354249058439025.jpg/30x30bb.jpg',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts123/v4/d1/58/f4/d158f4b6-e96f-a2ca-e218-2232127bd6fa/mza_1742354249058439025.jpg/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts123/v4/d1/58/f4/d158f4b6-e96f-a2ca-e218-2232127bd6fa/mza_1742354249058439025.jpg/100x100bb.jpg',
      collectionPrice: 0.0,
      trackPrice: 0.0,
      trackRentalPrice: 0,
      collectionHdPrice: 0,
      trackHdPrice: 0,
      trackHdRentalPrice: 0,
      releaseDate: '2018-08-17T22:59:00Z',
      collectionExplicitness: 'cleaned',
      trackExplicitness: 'cleaned',
      trackCount: 290,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'TV & Film',
      contentAdvisoryRating: 'Clean',
      artworkUrl600:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts123/v4/d1/58/f4/d158f4b6-e96f-a2ca-e218-2232127bd6fa/mza_1742354249058439025.jpg/600x600bb.jpg',
      genreIds: ['1309', '26'],
      genres: ['TV & Film', 'Podcasts'],
    },
    {
      wrapperType: 'track',
      kind: 'podcast',
      artistId: 988505420,
      collectionId: 979998616,
      trackId: 979998616,
      artistName: 'UNSC ONI',
      collectionName: 'HUNT the TRUTH',
      trackName: 'HUNT the TRUTH',
      collectionCensoredName: 'HUNT the TRUTH',
      trackCensoredName: 'HUNT the TRUTH',
      artistViewUrl:
        'https://podcasts.apple.com/us/artist/hunt-the-truth/988505420?uo=4',
      collectionViewUrl:
        'https://podcasts.apple.com/us/podcast/hunt-the-truth/id979998616?uo=4',
      feedUrl: 'http://feeds.feedburner.com/HuntTheTruth',
      trackViewUrl:
        'https://podcasts.apple.com/us/podcast/hunt-the-truth/id979998616?uo=4',
      artworkUrl30:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/9d/a7/92/9da792ce-3638-db99-3a13-502d09378786/mza_9199149855849398351.jpg/30x30bb.jpg',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/9d/a7/92/9da792ce-3638-db99-3a13-502d09378786/mza_9199149855849398351.jpg/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/9d/a7/92/9da792ce-3638-db99-3a13-502d09378786/mza_9199149855849398351.jpg/100x100bb.jpg',
      collectionPrice: 0.0,
      trackPrice: 0.0,
      trackRentalPrice: 0,
      collectionHdPrice: 0,
      trackHdPrice: 0,
      trackHdRentalPrice: 0,
      releaseDate: '2015-12-08T19:54:00Z',
      collectionExplicitness: 'cleaned',
      trackExplicitness: 'cleaned',
      trackCount: 23,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Video Games',
      contentAdvisoryRating: 'Clean',
      artworkUrl600:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/9d/a7/92/9da792ce-3638-db99-3a13-502d09378786/mza_9199149855849398351.jpg/600x600bb.jpg',
      genreIds: ['1509', '26', '1502'],
      genres: ['Video Games', 'Podcasts', 'Leisure'],
    },
    {
      wrapperType: 'track',
      kind: 'podcast',
      collectionId: 1188142876,
      trackId: 1188142876,
      artistName: 'Tofugu',
      collectionName: 'The Tofugu Podcast: Japan and Japanese Language',
      trackName: 'The Tofugu Podcast: Japan and Japanese Language',
      collectionCensoredName: 'The Tofugu Podcast: Japan and Japanese Language',
      trackCensoredName: 'The Tofugu Podcast: Japan and Japanese Language',
      collectionViewUrl:
        'https://podcasts.apple.com/us/podcast/the-tofugu-podcast-japan-and-japanese-language/id1188142876?uo=4',
      feedUrl:
        'http://feeds.soundcloud.com/users/soundcloud:users:187841578/sounds.rss',
      trackViewUrl:
        'https://podcasts.apple.com/us/podcast/the-tofugu-podcast-japan-and-japanese-language/id1188142876?uo=4',
      artworkUrl30:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/7d/d0/2a/7dd02a27-c6cf-d670-e7b0-4e1a78d125b5/mza_165296118068062469.jpg/30x30bb.jpg',
      artworkUrl60:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/7d/d0/2a/7dd02a27-c6cf-d670-e7b0-4e1a78d125b5/mza_165296118068062469.jpg/60x60bb.jpg',
      artworkUrl100:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/7d/d0/2a/7dd02a27-c6cf-d670-e7b0-4e1a78d125b5/mza_165296118068062469.jpg/100x100bb.jpg',
      collectionPrice: 0.0,
      trackPrice: 0.0,
      trackRentalPrice: 0,
      collectionHdPrice: 0,
      trackHdPrice: 0,
      trackHdRentalPrice: 0,
      releaseDate: '2020-09-04T16:27:00Z',
      collectionExplicitness: 'cleaned',
      trackExplicitness: 'cleaned',
      trackCount: 88,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Education',
      contentAdvisoryRating: 'Clean',
      artworkUrl600:
        'https://is5-ssl.mzstatic.com/image/thumb/Podcasts113/v4/7d/d0/2a/7dd02a27-c6cf-d670-e7b0-4e1a78d125b5/mza_165296118068062469.jpg/600x600bb.jpg',
      genreIds: ['1304', '26'],
      genres: ['Education', 'Podcasts'],
    },
    {
      wrapperType: 'track',
      kind: 'podcast',
      artistId: 204647080,
      collectionId: 984724892,
      trackId: 984724892,
      artistName: 'IGN',
      collectionName: 'IGN Anime Club',
      trackName: 'IGN Anime Club',
      collectionCensoredName: 'IGN Anime Club',
      trackCensoredName: 'IGN Anime Club',
      artistViewUrl: 'https://podcasts.apple.com/us/artist/ign/204647080?uo=4',
      collectionViewUrl:
        'https://podcasts.apple.com/us/podcast/ign-anime-club/id984724892?uo=4',
      feedUrl: 'http://feeds.feedburner.com/IgnAnimeClub',
      trackViewUrl:
        'https://podcasts.apple.com/us/podcast/ign-anime-club/id984724892?uo=4',
      artworkUrl30:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/e7/d7/3c/e7d73ccc-5d31-a2be-973e-7b6a38f2ad1c/mza_340214532546031532.png/30x30bb.jpg',
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/e7/d7/3c/e7d73ccc-5d31-a2be-973e-7b6a38f2ad1c/mza_340214532546031532.png/60x60bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/e7/d7/3c/e7d73ccc-5d31-a2be-973e-7b6a38f2ad1c/mza_340214532546031532.png/100x100bb.jpg',
      collectionPrice: 0.0,
      trackPrice: 0.0,
      trackRentalPrice: 0,
      collectionHdPrice: 0,
      trackHdPrice: 0,
      trackHdRentalPrice: 0,
      releaseDate: '2017-04-13T21:48:00Z',
      collectionExplicitness: 'cleaned',
      trackExplicitness: 'cleaned',
      trackCount: 87,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'TV & Film',
      contentAdvisoryRating: 'Clean',
      artworkUrl600:
        'https://is2-ssl.mzstatic.com/image/thumb/Podcasts113/v4/e7/d7/3c/e7d73ccc-5d31-a2be-973e-7b6a38f2ad1c/mza_340214532546031532.png/600x600bb.jpg',
      genreIds: ['1309', '26'],
      genres: ['TV & Film', 'Podcasts'],
    },
    {
      wrapperType: 'track',
      kind: 'podcast',
      collectionId: 260716482,
      trackId: 260716482,
      artistName: 'Bungie',
      collectionName: 'The Bungie Podcast',
      trackName: 'The Bungie Podcast',
      collectionCensoredName: 'The Bungie Podcast',
      trackCensoredName: 'The Bungie Podcast',
      collectionViewUrl:
        'https://podcasts.apple.com/us/podcast/the-bungie-podcast/id260716482?uo=4',
      feedUrl: 'https://www.bungie.net/podcast/bungiepodcast.xml',
      trackViewUrl:
        'https://podcasts.apple.com/us/podcast/the-bungie-podcast/id260716482?uo=4',
      artworkUrl30:
        'https://is4-ssl.mzstatic.com/image/thumb/Podcasts123/v4/78/bf/82/78bf822c-b612-51c7-731f-df72a90f0819/mza_8727337641953285918.jpg/30x30bb.jpg',
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Podcasts123/v4/78/bf/82/78bf822c-b612-51c7-731f-df72a90f0819/mza_8727337641953285918.jpg/60x60bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Podcasts123/v4/78/bf/82/78bf822c-b612-51c7-731f-df72a90f0819/mza_8727337641953285918.jpg/100x100bb.jpg',
      collectionPrice: 0.0,
      trackPrice: 0.0,
      trackRentalPrice: 0,
      collectionHdPrice: 0,
      trackHdPrice: 0,
      trackHdRentalPrice: 0,
      releaseDate: '2017-11-29T22:00:00Z',
      collectionExplicitness: 'explicit',
      trackExplicitness: 'explicit',
      trackCount: 46,
      country: 'USA',
      currency: 'USD',
      primaryGenreName: 'Video Games',
      contentAdvisoryRating: 'Explicit',
      artworkUrl600:
        'https://is4-ssl.mzstatic.com/image/thumb/Podcasts123/v4/78/bf/82/78bf822c-b612-51c7-731f-df72a90f0819/mza_8727337641953285918.jpg/600x600bb.jpg',
      genreIds: ['1509', '26', '1502', '1318'],
      genres: ['Video Games', 'Podcasts', 'Leisure', 'Technology'],
    },
  ],
  software: [
    {
      screenshotUrls: [
        'https://is3-ssl.mzstatic.com/image/thumb/Purple113/v4/8b/ed/22/8bed22b7-14ac-6d33-33d8-8fbb9a79dda7/mzl.wdqorklp.jpg/392x696bb.jpg',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/08/59/be/0859be9f-155a-dc3d-611e-eed32ffe552a/mzl.dyjwoscb.jpg/392x696bb.jpg',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/12/39/13/1239133a-000d-81c2-581b-6af5408e80ab/mzl.wvoznnna.png/392x696bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/71/6d/73/716d733d-e00b-9634-172f-ba54cb00e71f/mzl.rjysvidc.jpg/392x696bb.jpg',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple123/v4/0b/2a/09/0b2a0965-f3cc-71c2-aed2-56b93c4f0f71/mzl.unobyuks.png/392x696bb.png',
      ],
      ipadScreenshotUrls: [],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/80/57/7d/80577d9c-d962-bbfb-4cbf-e608ad88bde7/source/60x60bb.jpg',
      artworkUrl512:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/80/57/7d/80577d9c-d962-bbfb-4cbf-e608ad88bde7/source/512x512bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/80/57/7d/80577d9c-d962-bbfb-4cbf-e608ad88bde7/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/instagram-inc/id389801255?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: [
        'Infrequent/Mild Profanity or Crude Humor',
        'Infrequent/Mild Sexual Content and Nudity',
        'Infrequent/Mild Alcohol, Tobacco, or Drug Use or References',
        'Infrequent/Mild Mature/Suggestive Themes',
      ],
      kind: 'software',
      isGameCenterEnabled: false,
      features: [],
      trackCensoredName: 'Instagram',
      languageCodesISO2A: [
        'HR',
        'CS',
        'DA',
        'NL',
        'EN',
        'FI',
        'FR',
        'DE',
        'EL',
        'HI',
        'HU',
        'ID',
        'IT',
        'JA',
        'KO',
        'MS',
        'NB',
        'PL',
        'PT',
        'RO',
        'RU',
        'ZH',
        'SK',
        'ES',
        'SV',
        'TL',
        'TH',
        'ZH',
        'TR',
        'UK',
        'VI',
      ],
      fileSizeBytes: '159063040',
      sellerUrl: 'http://instagram.com/',
      contentAdvisoryRating: '12+',
      averageUserRatingForCurrentVersion: 4.77930999999999972516206980799324810504913330078125,
      userRatingCountForCurrentVersion: 18280279,
      averageUserRating: 4.77930999999999972516206980799324810504913330078125,
      trackViewUrl: 'https://apps.apple.com/us/app/instagram/id389801252?uo=4',
      trackContentRating: '12+',
      primaryGenreId: 6008,
      sellerName: 'Instagram, Inc.',
      trackId: 389801252,
      trackName: 'Instagram',
      releaseNotes:
        'The latest version contains bug fixes and performance improvements.',
      currentVersionReleaseDate: '2020-09-14T14:52:32Z',
      minimumOsVersion: '11.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6008', '6005'],
      primaryGenreName: 'Photo & Video',
      releaseDate: '2010-10-06T08:12:41Z',
      version: '159.0',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 389801255,
      artistName: 'Instagram, Inc.',
      genres: ['Photo & Video', 'Social Networking'],
      price: 0.0,
      description:
        "Bringing you closer to the people and things you love. — Instagram from Facebook\n\nConnect with friends, share what you’re up to, or see what's new from others all over the world. Explore our community where you can feel free to be yourself and share everything from your daily moments to life's highlights.\n\nExpress Yourself and Connect With Friends\n\n- Add photos and videos to your story that disappear after 24 hours, and bring them to life with fun creative tools.\n- Message your friends in Direct. Start fun conversations about what you see on Feed and Stories.\n- Post photos and videos to your feed that you want to show on your profile.\n\nLearn More About Your Interests\n\n- Check out IGTV for longer videos from your favorite creators.\n- Get inspired by photos and videos from new accounts in Explore.\n- Discover brands and small businesses, and shop products that are relevant to your personal style.",
      bundleId: 'com.burbn.instagram',
      userRatingCount: 18280279,
    },
    {
      screenshotUrls: [
        'https://is5-ssl.mzstatic.com/image/thumb/Purple113/v4/b8/0b/2c/b80b2c07-9899-0e80-fd96-e168a4ea657f/pr_source.png/392x696bb.png',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple123/v4/9c/6f/62/9c6f6288-3ea2-0693-a799-a3d918601fe0/pr_source.png/392x696bb.png',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/e2/b8/c4/e2b8c4bd-0c73-b3cf-693a-0b087b507322/pr_source.png/392x696bb.png',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/6b/7e/23/6b7e23dd-f967-77a5-66c6-55e35c81619a/pr_source.png/392x696bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/b6/38/3e/b6383ea7-48b2-2a92-370f-6e1d3c5a18b1/pr_source.png/392x696bb.png',
      ],
      ipadScreenshotUrls: [
        'https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/a2/ff/e2/a2ffe2cd-22f0-fdd9-0dbb-58a3d5bc1c23/mzl.ghlgunye.png/576x768bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/90/9c/36/909c363a-a230-f747-1e6d-bda15a1f19c3/mzl.ouqckawq.png/552x414bb.png',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple113/v4/49/8e/3f/498e3fa7-19e9-93df-e5ba-8c549747a921/mzl.xbivmonc.png/576x768bb.png',
      ],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/d1/fb/88/d1fb8829-6f98-d2a2-d130-6719f9104409/source/60x60bb.jpg',
      artworkUrl512:
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/d1/fb/88/d1fb8829-6f98-d2a2-d130-6719f9104409/source/512x512bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/d1/fb/88/d1fb8829-6f98-d2a2-d130-6719f9104409/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/facebook-inc/id284882218?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPadFourthGen-iPadFourthGen',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'Watch4-Watch4',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'Watch5-Watch5',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPhone5-iPhone5',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPadFourthGen4G-iPadFourthGen4G',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPhone5c-iPhone5c',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: [
        'Infrequent/Mild Alcohol, Tobacco, or Drug Use or References',
        'Infrequent/Mild Profanity or Crude Humor',
        'Infrequent/Mild Mature/Suggestive Themes',
        'Infrequent/Mild Sexual Content and Nudity',
      ],
      kind: 'software',
      isGameCenterEnabled: false,
      features: ['iosUniversal'],
      trackCensoredName: 'Facebook',
      languageCodesISO2A: [
        'AR',
        'HR',
        'CS',
        'DA',
        'NL',
        'EN',
        'FI',
        'FR',
        'DE',
        'EL',
        'HE',
        'HI',
        'HU',
        'ID',
        'IT',
        'JA',
        'KO',
        'MS',
        'NB',
        'PL',
        'PT',
        'RO',
        'RU',
        'ZH',
        'SK',
        'ES',
        'SV',
        'TH',
        'ZH',
        'TR',
        'VI',
      ],
      fileSizeBytes: '462683136',
      sellerUrl: 'http://www.facebook.com/mobile',
      contentAdvisoryRating: '12+',
      averageUserRatingForCurrentVersion: 3.051530000000000075743855632026679813861846923828125,
      userRatingCountForCurrentVersion: 531122,
      averageUserRating: 3.051530000000000075743855632026679813861846923828125,
      trackViewUrl: 'https://apps.apple.com/us/app/facebook/id284882215?uo=4',
      trackContentRating: '12+',
      primaryGenreId: 6005,
      sellerName: 'Facebook, Inc.',
      trackId: 284882215,
      trackName: 'Facebook',
      releaseNotes:
        'We update the app regularly so we can make it better for you. Get the latest version for all of the available Facebook features. This version includes several bug fixes and performance improvements.',
      currentVersionReleaseDate: '2020-09-10T16:34:37Z',
      minimumOsVersion: '10.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6005'],
      primaryGenreName: 'Social Networking',
      releaseDate: '2019-02-05T08:00:00Z',
      version: '287.0',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 284882218,
      artistName: 'Facebook, Inc.',
      genres: ['Social Networking'],
      price: 0.0,
      description:
        "Connect with friends, family and people who share the same interests as you. Communicate privately, watch your favorite content, buy and sell items or just spend time with your community. On Facebook, keeping up with the people who matter most is easy. Discover, enjoy and do more together.\n  \nStay up to date with your loved ones:\n  • Share what's on your mind, announce major life events through posts and celebrate the everyday moments with Stories.\n  • Express yourself through your profile and posts, watch, react, interact and stay in touch with your friends, throughout\n  the day.\n\nConnect with people who share your interests with Groups:\n  • With tens of millions of groups, you'll find something for all your interests and discover more groups relevant to you.\n  • Use the Groups tab as a hub to quickly access all your groups content. Find relevant groups based on your interests with the new discovery tool and recommendations.\n\nBecome more involved with your community:\n  • Discover events happening near you, businesses to support, local groups and activities to be part of.\n  • Check out local recommendations from your friends, then coordinate with them and make plans to get together.\n  • Raise funds for a cause that’s important to you, mentor someone who wants help achieving their goals and, in the event of a local crisis, connect with other people to find or give supplies, food or shelter.\n\nEnjoy entertainment together with Watch:\n  • Discover all kinds of content from original shows to creators to trending videos in topics like beauty, sports, and entertainment.\n  • Join conversations, share with others, interact with viewers and creators and watch together like never before.\n\nBuy and sell with Marketplace:\n  • Whether it's an everyday or one-of-a-kind item, you can discover everything from household items to your next car or apartment on Marketplace.\n  • List your own item for sale and conveniently communicate with buyers and sellers through Messenger \n\nRead our Data Use Policy, Terms and other important info in the legal section of our App Store description. \n\nContinued use of GPS running in the background can dramatically decrease battery life. Facebook doesn't run GPS in the background unless you give us permission by turning on optional features that require this.",
      bundleId: 'com.facebook.Facebook',
      userRatingCount: 531122,
    },
    {
      screenshotUrls: [
        'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/63/95/4d/63954d4c-1cec-c34c-7754-14cec445b741/mzl.vlfvccak.png/392x696bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/3e/74/d9/3e74d9e4-e47f-d251-858a-f75efced99b6/mzl.ibbetulh.png/392x696bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/f6/41/55/f64155dc-397e-215c-4be3-bd1934b8f4c1/mzl.mjneakpu.png/392x696bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/f0/1c/d1/f01cd128-00a3-90f4-5f4e-88f3f6a5cfa3/pr_source.png/392x696bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/37/45/68/3745686b-551d-44b4-6436-dfd7b560691e/mzl.oieaqswn.png/392x696bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/76/06/6a/76066a7e-b26b-b4dd-942e-f41ee38ad691/mzl.sbeqcclk.png/392x696bb.png',
      ],
      ipadScreenshotUrls: [
        'https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/59/89/61/598961b3-906b-0207-0a3f-9b8cc27509dc/mzl.ndplzvpl.png/552x414bb.png',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple113/v4/1a/1f/fa/1a1ffa65-33ba-3014-ba5d-758b4c48c654/mzl.mhiklstj.png/576x768bb.png',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple123/v4/fb/dc/88/fbdc8869-6566-c727-cf91-2ad27fafd1a4/mzl.bzidgxrs.png/576x768bb.png',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple113/v4/07/b1/fa/07b1fa2d-d77e-a4b0-a65f-3c7335e684f0/mzl.cwkepclx.png/576x768bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/7a/0e/e2/7a0ee29d-7175-d2ed-7291-e214fac4069e/pr_source.png/576x768bb.png',
      ],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/6f/4f/e0/6f4fe057-2a15-1d4e-6847-e8e3b4d12cd9/source/60x60bb.jpg',
      artworkUrl512:
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/6f/4f/e0/6f4fe057-2a15-1d4e-6847-e8e3b4d12cd9/source/512x512bb.jpg',
      artworkUrl100:
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/6f/4f/e0/6f4fe057-2a15-1d4e-6847-e8e3b4d12cd9/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/line-corporation/id359067226?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'Watch4-Watch4',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: ['Infrequent/Mild Medical/Treatment Information'],
      kind: 'software',
      isGameCenterEnabled: false,
      features: ['iosUniversal'],
      trackCensoredName: 'LINE',
      languageCodesISO2A: [
        'AR',
        'EN',
        'FR',
        'DE',
        'ID',
        'IT',
        'JA',
        'KO',
        'MS',
        'PT',
        'RU',
        'ZH',
        'ES',
        'TH',
        'ZH',
        'TR',
        'VI',
      ],
      fileSizeBytes: '283252736',
      sellerUrl: 'http://line.me/',
      contentAdvisoryRating: '12+',
      averageUserRatingForCurrentVersion: 3.531620000000000203499439521692693233489990234375,
      userRatingCountForCurrentVersion: 10199,
      averageUserRating: 3.531620000000000203499439521692693233489990234375,
      trackViewUrl: 'https://apps.apple.com/us/app/line/id443904275?uo=4',
      trackContentRating: '12+',
      primaryGenreId: 6005,
      sellerName: 'LINE Corporation',
      trackId: 443904275,
      trackName: 'LINE',
      releaseNotes:
        '• The Watch together feature, which lets you view YouTube with others in group calls, is now easier to use from chats.',
      currentVersionReleaseDate: '2020-08-20T02:19:18Z',
      minimumOsVersion: '11.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6005'],
      primaryGenreName: 'Social Networking',
      releaseDate: '2011-06-23T06:26:02Z',
      version: '10.14.0',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 359067226,
      artistName: 'LINE Corporation',
      genres: ['Social Networking'],
      price: 0.0,
      description:
        "LINE reshapes communication around the globe, bringing you closer to your family, friends, and loved ones—for free. With voice and video calls, messages, and a limitless variety of exciting stickers, you’ll be able to express yourself in ways that you’ve never thought possible. With over 600 million users worldwide, LINE’s constantly expanding platform will continue to provide exciting new experiences and convenience.\n\nNOTICE:\nLINE Pay services in Singapore, LINE Biz+ Pte. Ltd. (\"LINE Biz+\") discontinued its provision of the LINE Pay services from 8 February 2018 onwards. \n\nLINE’s New Features\n\nMake Group Calls with 500 People: Try our group call feature with members in chats.\n\nKeep Your Things Close with Keep: Store messages, photos, and videos in Keep and share them easily with friends.\n\nLINE’s Main Features\n\nFree voice and video calls: Use your PC or smartphone to keep in touch with friends and family both at home and abroad, or hold a business meeting on the go!\n\nInstant messaging anywhere: Conversation is just a tap away. Spice it up with LINE’s exciting collection of stickers or send pictures, videos, and even GPS coordinates to let your friends know what you’re up to.\n\nA full-featured social networking service: Post your day-to-day activities to your Timeline or comment on your friends’ posts.\n\nGroup chats: Share important information with your co-workers or talk about mutual interests with your closest friends.\n\nFind new expressions in the Sticker Shop: The world’s largest collection of stickers features famous and unique characters from around the world to let you express yourself just the way you want to.\n\nStay informed with LINE official accounts: Connect directly with your favorite celebrities and companies by friending their official accounts.\n\nMake international calls with LINE Out: Make international calls to mobile phones and landlines at competitively low rates. You can even call friends who aren't LINE users (available in certain countries only).\n\nGet connected to new apps: LINE provides a gateway to entertainment and lifestyle apps that will keep you entertained and bring new convenience to your life.\n\nMake your face the center of action in Face Play games: Get ready to stretch those facial muscles! Rack up new high scores in solo mode, or battle it out with your friends in duo mode for double the fun. Don't forget to collect your special trophy and skin when you complete a mission or become the season champion!\n\nIntroducing LINE Fan Account!\n\nPrice plans:\n• 1-month plan\nPrice: JPY 480 (tax included)\nDuration: One month\n\n• 12-month plan\nPrice: JPY 5,700 (tax included)\nDuration: One year\n\nSupported countries:\nJapan\n\nPurchasing a plan:\n• Your iTunes account will be charged at the time of purchase.\n• Your plan will be automatically renewed and your iTunes account charged 24 hours before your plan's expiration date.\n• You'll receive a free seven-day trial with your first plan purchase. Your account will be charged at the end of the free trial.\nYou won't be charged if you cancel your plan before the end of the free trial.\n\nCanceling auto-renewal:\n• To prevent your plan from renewing itself automatically, please turn off the auto-renewal option at least 24 hours before your plan's expiration date.\n• You can still use your plan until it expires after canceling auto-renewal.\n\nViewing or canceling your plan:\n• To view or cancel an existing plan, check your App Store purchase history from your device's settings.\n\nTerms and Conditions of Use:\n• https://terms2.line.me/Disney_terms_web\n\nPrivacy Policy:\n• https://terms.line.me/line_rules\n\nWe recommend that you use LINE with iOS versions 10.0 or higher with an iPhone 5 or above.\n\nFor more information about LINE, check out our official website.\nhttp://line.me/en/",
      bundleId: 'jp.naver.line',
      userRatingCount: 10199,
    },
    {
      screenshotUrls: [
        'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/9e/f5/4a/9ef54a24-ef48-8ac8-3f99-fb02b7d3d254/pr_source.png/392x696bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/db/04/91/db04918c-2749-59a9-a733-820565dc7656/pr_source.png/392x696bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/9e/b1/a9/9eb1a9f5-fab1-997e-9c73-035952c6dc15/pr_source.png/392x696bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/24/7e/d8/247ed848-4b3c-63ae-f2ec-ca0e38623758/pr_source.png/392x696bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/64/69/1b/64691b47-c7c3-ac12-cb8b-a559f9b54f70/pr_source.png/392x696bb.png',
      ],
      ipadScreenshotUrls: [
        'https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/f9/fe/a8/f9fea873-4882-4ddc-18f4-c939439bcc7a/mzl.iminvglq.png/576x768bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/4f/00/60/4f00601f-e9b2-af4c-8270-f41a0c2371eb/mzl.rwpqyyls.jpg/576x768bb.jpg',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple113/v4/39/ce/5e/39ce5e49-917c-2f6e-2e70-c954316c3222/mzl.rsxtmqvp.jpg/576x768bb.jpg',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/a6/11/99/a611998e-8e69-f5c1-f482-9bbcb956bd57/mzl.wwkyjvav.jpg/576x768bb.jpg',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/bd/2e/c1/bd2ec17e-2478-8927-7abb-2a1c53ba2596/mzl.bgrtklin.jpg/576x768bb.jpg',
      ],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/4f/19/db/4f19dbf6-b167-9e8f-71a8-da2f41dce04e/source/60x60bb.jpg',
      artworkUrl512:
        'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/4f/19/db/4f19dbf6-b167-9e8f-71a8-da2f41dce04e/source/512x512bb.jpg',
      artworkUrl100:
        'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/4f/19/db/4f19dbf6-b167-9e8f-71a8-da2f41dce04e/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/visual-supply-company/id513526768?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: [
        'Infrequent/Mild Realistic Violence',
        'Infrequent/Mild Mature/Suggestive Themes',
        'Infrequent/Mild Alcohol, Tobacco, or Drug Use or References',
      ],
      kind: 'software',
      isGameCenterEnabled: false,
      features: ['iosUniversal'],
      trackCensoredName: 'VSCO: Photo & Video Editor',
      languageCodesISO2A: [
        'AR',
        'MY',
        'KM',
        'ZH',
        'DA',
        'NL',
        'EN',
        'ET',
        'FI',
        'FR',
        'DE',
        'HE',
        'HI',
        'ID',
        'IT',
        'JA',
        'KO',
        'LO',
        'MS',
        'NB',
        'PL',
        'PT',
        'RU',
        'ZH',
        'ES',
        'SV',
        'TH',
        'ZH',
        'TR',
        'VI',
      ],
      fileSizeBytes: '136678400',
      sellerUrl: 'http://vsco.co/vscocam',
      contentAdvisoryRating: '12+',
      averageUserRatingForCurrentVersion: 4.31867000000000000881072992342524230480194091796875,
      userRatingCountForCurrentVersion: 36339,
      averageUserRating: 4.31867000000000000881072992342524230480194091796875,
      trackViewUrl:
        'https://apps.apple.com/us/app/vsco-photo-video-editor/id588013838?uo=4',
      trackContentRating: '12+',
      primaryGenreId: 6008,
      sellerName: 'Visual Supply Company',
      trackId: 588013838,
      trackName: 'VSCO: Photo & Video Editor',
      releaseNotes:
        "What’s new on VSCO\n\n— Fixes for top crashes\n— Smaller bug fixes and performance improvements\n\nThanks for creating with VSCO! We regularly release updates to improve your experience. Update to the latest version of VSCO for access to our newest presets, editing tools, and inspiring content.\n\nIf you'd like our help with any issues, please visit vs.co/help.",
      currentVersionReleaseDate: '2020-09-14T08:07:58Z',
      minimumOsVersion: '12.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6008', '6012'],
      primaryGenreName: 'Photo & Video',
      releaseDate: '2013-06-06T14:55:36Z',
      version: '182.0',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 513526768,
      artistName: 'Visual Supply Company',
      genres: ['Photo & Video', 'Lifestyle'],
      price: 0.0,
      description:
        'VSCO is a place where expression matters most. We offer creative photo and video editing tools, inspiration, and a place for you to be you. \n\nShare your photos and videos with #VSCO for a chance to be curated by VSCO. We can’t wait to see what you create.\n\nFREE PHOTO EDITOR\nTake your photography to the next level with 10 free VSCO presets. Easily import and edit your RAW photos. Use editing tools like Contrast and Saturation to make your photos pop or use Grain and Fade to add texture and mimic analog film effects. Adjust or play around with your photo perspectives with Crop and Skew. Save and recreate your favorite edits with Recipes. \n\nADVANCED PHOTO EDITING TOOLS\nJoin VSCO Membership to access VSCO’s complete preset library with over 200+ presets. Recreate vintage film looks by Kodak, Fuji, Agfa, and others with Film X. Use advanced photo editing tools like HSL and Split Tone. Frame your images with a touch of color using Borders.\n\nVIDEO EDITOR\nTransform your videos on mobile with the same premium VSCO presets and advanced editing tools from our photo editor. Adjust white balance and experiment with color control with HSL. Easily create short video GIFs with DSCO.\n\nVSCO MONTAGE\nTell a video story and make a moving collage by layering videos, images, and shapes. Celebrate moments, illustrate a mood, or experiment with photos and videos you already have in your Studio. Adjust the opacity of any media layered in to create an eclectic range of customized gel colors and double exposures.﻿﻿\n\nCONNECT WITH A CREATIVE COMMUNITY \nExplore inspiring photos, videos, and editorial in Discover. Find people you know and connect with friends already on VSCO. Create with Journals. Try something new with weekly photo Challenges exclusive to your VSCO membership.\n\nMEMBERSHIP TRIAL AND SUBSCRIPTION TERMS\nStart your VSCO membership with a free 7-day trial. Once the trial is over, you’ll be charged an annual subscription fee. Your VSCO membership will automatically renew unless auto-renew is turned off at least 24 hours before the end of the current period. You can go to your Settings > iTunes Account & App Store > Apple ID > Subscriptions to manage your membership and turn auto-renew off. Your iTunes Account will be charged when the purchase is confirmed.\n\nRead more about our terms and conditions here —\nhttp://vsco.co/about/terms_of_use\n\nRead more about our privacy policy here —\nhttp://vsco.co/about/privacy_policy',
      bundleId: 'co.visualsupply.cam',
      userRatingCount: 36339,
    },
    {
      screenshotUrls: [
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/1c/4b/a2/1c4ba232-e45d-bbec-270c-3f3929ea50db/bc21b646-aafb-46f3-beb1-fad4be1755f6_2208x1242-1.png/406x228bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/99/fa/13/99fa13db-3807-5df8-c18a-2648a17fa402/f9805927-57ea-4a42-a42d-bfcbf2d714ea_2208x1242-2.png/406x228bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/02/58/65/02586595-baac-17a2-ef79-091f91c7d004/pr_source.png/406x228bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple124/v4/63/75/76/637576d2-1602-8c8c-ee09-679b031c5fd9/pr_source.png/406x228bb.png',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/70/a8/9f/70a89f81-2fa2-b274-1b65-e9747726d43a/pr_source.png/406x228bb.png',
        'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/4b/ad/a4/4bada43e-dde6-6cc5-e84b-7d35f2031136/pr_source.png/406x228bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/22/6e/43/226e434a-a30e-befb-0f02-25cb1a93b9d5/89bb0b8f-41bc-442c-9f39-aaa456f0750d_CN-2208x1242-7.png/406x228bb.png',
      ],
      ipadScreenshotUrls: [
        'https://is2-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/06/18/16/06181617-33b4-6e95-6ed1-b8a2d12d686c/4eefcff6-d50b-4ade-832f-3ec6a809b63d_2732X2048-1.png/552x414bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/ae/07/ce/ae07ce8b-f3c0-78fa-81dd-e84852dcce54/4f675c68-58af-498e-af90-b2dafe30e149_2732X2048-2.png/552x414bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple114/v4/37/d1/28/37d1280e-d3a1-a9f3-c443-9dd22535f9ea/pr_source.png/552x414bb.png',
        'https://is3-ssl.mzstatic.com/image/thumb/Purple124/v4/c7/56/42/c7564249-8544-8148-d41c-246ba28aa65d/pr_source.png/552x414bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple114/v4/a8/0a/2e/a80a2e2b-7823-36c5-cc76-6f33eab94aaa/pr_source.png/552x414bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/ca/78/97/ca78972d-876f-f877-4b3d-b7ff79e1f451/pr_source.png/552x414bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/fe/f7/65/fef765b3-2e45-f41b-d73a-35ebaa15f951/mzl.pdupcffy.png/552x414bb.png',
      ],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/1d/85/55/1d8555dc-73b8-d2eb-e2b2-83f02442d8de/source/60x60bb.jpg',
      artworkUrl512:
        'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/1d/85/55/1d8555dc-73b8-d2eb-e2b2-83f02442d8de/source/512x512bb.jpg',
      artworkUrl100:
        'https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/1d/85/55/1d8555dc-73b8-d2eb-e2b2-83f02442d8de/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/mihoyo-limited/id1286705195?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: [
        'Infrequent/Mild Sexual Content and Nudity',
        'Frequent/Intense Cartoon or Fantasy Violence',
        'Infrequent/Mild Simulated Gambling',
        'Infrequent/Mild Mature/Suggestive Themes',
        'Frequent/Intense Profanity or Crude Humor',
      ],
      kind: 'software',
      isGameCenterEnabled: false,
      features: ['iosUniversal'],
      trackCensoredName: 'Honkai Impact 3rd',
      languageCodesISO2A: ['EN', 'FR', 'DE', 'ZH'],
      fileSizeBytes: '3888138240',
      sellerUrl: 'https://honkaiimpact3.mihoyo.com/global/en-us/',
      contentAdvisoryRating: '12+',
      averageUserRatingForCurrentVersion: 4.7629999999999999005240169935859739780426025390625,
      userRatingCountForCurrentVersion: 24557,
      averageUserRating: 4.7629999999999999005240169935859739780426025390625,
      trackViewUrl:
        'https://apps.apple.com/us/app/honkai-impact-3rd/id1336342304?uo=4',
      trackContentRating: '12+',
      primaryGenreId: 6014,
      sellerName: 'miHoYo Limited',
      trackId: 1336342304,
      trackName: 'Honkai Impact 3rd',
      releaseNotes:
        "[New Battlesuits] S-rank Rita & Shadow Dash Augmented debut\n[New Event] Rosemary's Floriograph: Play to earn new free outfit\n[New Story] Into Earth Does the Water Flow: Story Chapter XIX released \n[New Equipment] Weapon [Iris of the Dreams] & stigma set [Irene Adler] released",
      currentVersionReleaseDate: '2020-09-15T05:58:25Z',
      minimumOsVersion: '9.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6014', '7014', '7001'],
      primaryGenreName: 'Games',
      releaseDate: '2018-03-28T03:13:07Z',
      version: '4.2.0',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 1286705195,
      artistName: 'miHoYo Limited',
      genres: ['Games', 'Role Playing', 'Action'],
      price: 0.0,
      description:
        '[S-rank Battlesuit | Fallen Rosemary] \nHer origin and destination are known by none.\nNew S-rank battlesuit [Fallen Rosemary] debuts!\nShe will summon lonesome Disir to lead evil to the seedbed of demons!\n""I might as well keep you company for the time being~""\n\n[Augment Core | Danzai Spectramancer]\nTo protect her dearest one, she has set foot on her own path of thorns.\n[Shadow Dash] Augmented: [Danzai Spectramancer] debuts!\nHer dancing blade becomes the flash that will sunder the darkness and condemn evils!\n""I will walk this path alone!""\n\n[Battlesuit Event | Rosemary\'s Floriograph]\nA mysterious invite and a desolate city;\nA case of serial murder leading to a secret that is wildly beyond imagination.\nFollow Conan Doyle and his partner Hua in their investigation for the truth!\nOn your way to seek the truth, you will also earn Black Nucleus\'s new outfit and Ancient Willpower~\n\n[Story Chapter XIX | Into Earth Does the Water Flow]\nIs the seeping snowmelt a herald of victory or another ill omen?\nStory Chapter XIX released! Play to earn event set stigma and Focused Supply Card!\n\n[New Equipment] \nThe soul reaper from the age of mythology! Scythe [Iris of the Dreams] descends!\nUnleash unprecedented powers! PRI-ARMS [Surtr Muspellsverd] and [Shuhadaku of Uriel] have joined the arsenal!\nPhantom of the Fog set [Irene Adler] and Herrscher of Ice set [Ana Schariac] have joined the arsenal!\n\nHonkai Impact 3rd Subscription Service Features and Apple Subscription Service User Notice\n\n1. Subscription contents\n[Adventure Commander] (30 Days) / (90 Days) / (180 Days).\nClaim the following items daily:\n- Stamina Potion x2, Asterite x200, Mithril x1,000, 50% Captain EXP Chip x1\n\n[Valkyrie Guild] (30 Days) / (90 Days) / (180 Days).\nClaim following items daily :\n- Valkyrie Fragvyom x1.\n Open to randomly receive Battlesuit fragment x1 of the following:  Night Squire / Stalker: Phantom Iron / Yamabuki Armor / Valkyrie Pledge\n- Random Battlesuit Supply Crate.\nRandom Battlesuit fragment x1 and ADV EXP Chip x1. (Ai-chan\'s reminder: You may even receive S-rank battlesuit fragments!)\n*Subscription rewards are delivered to your mailbox on your first login daily.\n\n2. About Auto Renewal\n1) Apple subscription service automatically renews on default and is billed through iTunes Account. The Auto Renewal function can be manually turned off in iTunes/Apple ID Settings. Subscription automatically renews monthly 24 hours before the subscription period ends and is billed through iTunes Account. To cancel subscription, the Auto Renewal function must be turned off no later than 24 hours before the subscription period ends.\n2) Subscription services are billed through iTunes account.\n\n3. User Agreement: https://honkaiimpact3.mihoyo.com/global/en-us/terms\n\n4. Privacy Policy: https://honkaiimpact3.mihoyo.com/global/en-us/privacy\n\n5. How to cancel subscription\nPlease go to “Settings” and select the following options in order: “iTunes & App Store” > “Apple ID” > “View Apple ID” > “Account Settings” > “Subscriptions” > “Management”\n\n\n[SUPPORT]\nYou can  reach us via our customer service email:\nhonkai3rd_global@mihoyo.com\nHonkai Impact 3rd Official Site: https://honkaiimpact3.mihoyo.com/global/en-us/',
      bundleId: 'com.miHoYo.bh3global',
      userRatingCount: 24557,
    },
    {
      screenshotUrls: [
        'https://is2-ssl.mzstatic.com/image/thumb/Purple113/v4/61/6d/a7/616da731-9d73-3505-a721-461724c6dcb5/mzl.mvxpkkzb.png/392x696bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple113/v4/75/c4/83/75c483c8-c9c1-518a-2404-182a0ca7618b/mzl.iilxirec.png/392x696bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/7b/1d/f8/7b1df89b-8a93-975e-b97a-6ef71c313e14/pr_source.png/392x696bb.png',
        'https://is5-ssl.mzstatic.com/image/thumb/Purple123/v4/1f/94/f6/1f94f6b6-36c1-3512-c811-55f684a6e78d/pr_source.png/392x696bb.png',
        'https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/de/71/53/de71536c-1c1f-3e6b-5ba0-65b89679a058/mzl.xqddtyoq.png/392x696bb.png',
        'https://is4-ssl.mzstatic.com/image/thumb/Purple123/v4/c3/5f/7f/c35f7f0d-9c5b-e659-57b5-bf65b1aa2d43/mzl.duhcsmrw.png/392x696bb.png',
      ],
      ipadScreenshotUrls: [],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/a3/fe/96/a3fe96f6-08fb-ce54-31ca-8c1831340f3f/source/60x60bb.jpg',
      artworkUrl512:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/a3/fe/96/a3fe96f6-08fb-ce54-31ca-8c1831340f3f/source/512x512bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple114/v4/a3/fe/96/a3fe96f6-08fb-ce54-31ca-8c1831340f3f/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/simple-finance/id479317769?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: [],
      kind: 'software',
      isGameCenterEnabled: false,
      features: [],
      trackCensoredName: 'Simple - Mobile Banking',
      languageCodesISO2A: ['EN'],
      fileSizeBytes: '94179328',
      sellerUrl: 'https://www.simple.com',
      contentAdvisoryRating: '4+',
      averageUserRatingForCurrentVersion: 4.5495900000000002449951352900825440883636474609375,
      userRatingCountForCurrentVersion: 10295,
      averageUserRating: 4.5495900000000002449951352900825440883636474609375,
      trackViewUrl:
        'https://apps.apple.com/us/app/simple-mobile-banking/id479317486?uo=4',
      trackContentRating: '4+',
      primaryGenreId: 6015,
      sellerName: 'Simple Finance Technology Corp.',
      trackId: 479317486,
      trackName: 'Simple - Mobile Banking',
      releaseNotes:
        'This update contains tweaks, fixes, and good cheer!\n- Fixes a balance update issue\nHello smooth(er) sailing!',
      currentVersionReleaseDate: '2020-09-15T20:54:46Z',
      minimumOsVersion: '12.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6015'],
      primaryGenreName: 'Finance',
      releaseDate: '2012-05-10T01:04:53Z',
      version: '2.107.7',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 479317769,
      artistName: 'Simple Finance',
      genres: ['Finance'],
      price: 0.0,
      description:
        "Simple is one of the first mobile banking apps that has helped customers budget and save since 2012.\n\nBudget and save with no hidden bank fees, with balances in Protected Goals Accounts earning a competitive interest rate. \n\nEvery aspect of a Simple checking account is optimized for branchless online banking, budgeting, and saving, so you can track spending and manage your money wherever you happen to be. Simple is personal finance made easy.\n\nWithout setting foot in a branch (or a bank stuffed into an ill-fitting mobile app), you have access to:\n\n - Built-in budgeting and saving tools\n - Visa® Debit Card\n - Certificates of Deposit\n - Photo Check Deposit\n - FDIC-Insurance up to the legal limit\n - Direct Deposit\n - External Account Linking\n - Instant Transfers to Other Simple Customers\n - Third-Party Payment services like Square, Venmo, and Paypal\n - Block your card in the app if it's been lost or stolen\n\nSimple Goals\nUse Goals for saving money: Stash away money for the unexpected, or automate saving for things you want. From a trip to Italy to a new bike. Open a separate Protected Goals Account to keep money tucked away from spending while earning a competitive interest rate. \n\nSimple Expenses\nSet up your Expenses one time and going forward, we'll do the rest. When you pay your rent, your Expense is already saving money for next month's bill. Yep, it's our job now. (You can even split Expenses with a partner when using a Shared Account).\n\nNo-Penalty Certificate of Deposit\nPut your savings to work for you! Simple’s No-Penalty CDs let you lock in a rate that guarantees growth for your savings—so you’ll know exactly how much your deposit will earn. And a No-Penalty CD gives you peace of mind when stashing your cash.\n\nSafe-to-Spend®\nSpend money spontaneously, without derailing your budget or bills (or doing the math on the spot...). We take your account balance, subtract your Expenses and Goals, and tell you exactly how much money you have left over to spend on whatever you want. (Buy the shoes!)\n\nShared Accounts\nEarn interest with whoever you're interested in: When it comes to shared bills and savings goals, two paychecks are better than one! Open a Simple Shared account to tackle budgeting and save money together.\n\nRound-up Rules \nStart saving money effortlessly with Round-up Rules. Whenever you make a purchase, what you spend will be rounded up to the next whole dollar amount, and when those round-ups reach or exceed $5, that balance will be tucked away into your Protected Goals Account. It’s like a digital change jar...one that adds up to real money in the bank.\n\nTax Refund\nYour tax refund is your money, and the IRS has been hanging onto it all year! So when you finally get it back, put it to work! Commit to saving a portion of your return before you even receive it, and when it hits your account, it’ll automatically transfer into your Protected Goals Account to build your savings and earn interest.\n\n\nBanking Services provided by BBVA USA, Member FDIC. The Simple Visa® Card is issued by BBVA USA pursuant to a license from Visa U.S.A. Inc. and may be used everywhere Visa debit cards are accepted.",
      bundleId: 'com.simple.Simple',
      userRatingCount: 10295,
    },
    {
      screenshotUrls: [
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/49/d3/87/49d38773-5e47-f40c-32ab-2da2341caf5a/29357a05-b41c-43b8-bf08-5f78f4a42a0c_1.jpg/392x696bb.jpg',
        'https://is2-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/36/b9/77/36b9770a-fcf9-112a-a2c5-50667b60ffe8/b08d4073-14b1-4348-8d9c-c147de3edaef_2.jpg/392x696bb.jpg',
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/10/37/fc/1037fcf6-1197-0c1c-a77d-bfbafb06100c/1e7406bd-08d4-4345-b541-48d885afa9c8_3.jpg/392x696bb.jpg',
        'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/5e/12/4d/5e124dd6-4239-6630-ebaf-5c8102978527/3a29730b-b6d3-48f9-95a4-ec678f5492dc_4.jpg/392x696bb.jpg',
        'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/fb/d6/c8/fbd6c8aa-005b-883e-b5a6-a8126a61a588/6c0dab30-2226-4e7d-a7b8-a441bd40d00a_5.jpg/392x696bb.jpg',
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/c7/b6/05/c7b60515-dccf-8de0-cbcc-a2364c8c9223/070bea7e-0186-4de6-89b1-c090efa39c26_6.jpg/392x696bb.jpg',
        'https://is5-ssl.mzstatic.com/image/thumb/PurpleSource124/v4/fb/81/e3/fb81e338-2e6c-4a03-c04a-f0b4a16e5e6f/2dbe117d-c195-4777-95f6-199532fd2a2e_7.jpg/392x696bb.jpg',
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/e1/f1/67/e1f16771-35ef-ba6a-e103-03f3577f2e0b/796231ab-41bb-4d4c-a70c-7736994906b4_8.jpg/392x696bb.jpg',
        'https://is4-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/06/0a/49/060a49f3-c5f3-9920-1ce0-3d756ecba2de/becb9330-d475-4a7f-8caa-d198465f4e0c_9.jpg/392x696bb.jpg',
      ],
      ipadScreenshotUrls: [],
      appletvScreenshotUrls: [],
      artworkUrl60:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/79/60/3b/79603b5e-b42d-f24f-740a-917d18449f31/source/60x60bb.jpg',
      artworkUrl512:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/79/60/3b/79603b5e-b42d-f24f-740a-917d18449f31/source/512x512bb.jpg',
      artworkUrl100:
        'https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/79/60/3b/79603b5e-b42d-f24f-740a-917d18449f31/source/100x100bb.jpg',
      artistViewUrl:
        'https://apps.apple.com/us/developer/chime-financial-inc/id836215272?uo=4',
      supportedDevices: [
        'iPhone5s-iPhone5s',
        'iPadSeventhGen-iPadSeventhGen',
        'iPadProSecondGenCellular-iPadProSecondGenCellular',
        'iPad878-iPad878',
        'iPadProSecondGen-iPadProSecondGen',
        'iPadAir-iPadAir',
        'iPhone6sPlus-iPhone6sPlus',
        'iPad71-iPad71',
        'iPhone8Plus-iPhone8Plus',
        'iPhone11-iPhone11',
        'iPadAir2Cellular-iPadAir2Cellular',
        'iPhoneSE-iPhoneSE',
        'iPadMiniRetina-iPadMiniRetina',
        'iPhoneXSMax-iPhoneXSMax',
        'iPhone6Plus-iPhone6Plus',
        'iPadPro-iPadPro',
        'iPadAir2-iPadAir2',
        'iPad72-iPad72',
        'iPadMini5-iPadMini5',
        'iPadAir3Cellular-iPadAir3Cellular',
        'iPodTouchSixthGen-iPodTouchSixthGen',
        'iPad611-iPad611',
        'iPhone11Pro-iPhone11Pro',
        'iPad74-iPad74',
        'iPhone6-iPhone6',
        'iPhone8-iPhone8',
        'iPad812-iPad812',
        'iPhone7Plus-iPhone7Plus',
        'iPadMini4-iPadMini4',
        'iPadMiniRetinaCellular-iPadMiniRetinaCellular',
        'iPad76-iPad76',
        'iPadProFourthGen-iPadProFourthGen',
        'iPadProFourthGenCellular-iPadProFourthGenCellular',
        'iPadAirCellular-iPadAirCellular',
        'iPhone7-iPhone7',
        'iPad856-iPad856',
        'iPhone6s-iPhone6s',
        'iPhoneXS-iPhoneXS',
        'iPadMini5Cellular-iPadMini5Cellular',
        'iPhoneXR-iPhoneXR',
        'iPadPro97Cellular-iPadPro97Cellular',
        'iPad834-iPad834',
        'iPadProCellular-iPadProCellular',
        'iPad75-iPad75',
        'iPadPro97-iPadPro97',
        'iPadAir3-iPadAir3',
        'iPadMini3-iPadMini3',
        'iPad73-iPad73',
        'iPodTouchSeventhGen-iPodTouchSeventhGen',
        'iPadSeventhGenCellular-iPadSeventhGenCellular',
        'iPhone11ProMax-iPhone11ProMax',
        'iPadMini4Cellular-iPadMini4Cellular',
        'iPhoneSESecondGen-iPhoneSESecondGen',
        'iPad612-iPad612',
        'iPhoneX-iPhoneX',
        'iPadMini3Cellular-iPadMini3Cellular',
      ],
      advisories: [],
      kind: 'software',
      isGameCenterEnabled: false,
      features: [],
      trackCensoredName: 'Chime - Mobile Banking',
      languageCodesISO2A: [
        'AR',
        'MY',
        'KM',
        'ZH',
        'CS',
        'DA',
        'NL',
        'EN',
        'ET',
        'FI',
        'FR',
        'DE',
        'HE',
        'HI',
        'HU',
        'ID',
        'IT',
        'JA',
        'KO',
        'LO',
        'MS',
        'NO',
        'NB',
        'PL',
        'PT',
        'RO',
        'RU',
        'ZH',
        'SK',
        'ES',
        'SV',
        'TH',
        'ZH',
        'TR',
        'VI',
      ],
      fileSizeBytes: '69912576',
      sellerUrl: 'http://www.chime.com/',
      contentAdvisoryRating: '4+',
      averageUserRatingForCurrentVersion: 4.7791399999999999437250153278000652790069580078125,
      userRatingCountForCurrentVersion: 174981,
      averageUserRating: 4.7791399999999999437250153278000652790069580078125,
      trackViewUrl:
        'https://apps.apple.com/us/app/chime-mobile-banking/id836215269?uo=4',
      trackContentRating: '4+',
      primaryGenreId: 6015,
      sellerName: 'Chime Financial, Inc.',
      trackId: 836215269,
      trackName: 'Chime - Mobile Banking',
      releaseNotes:
        "Dear screen reader users: We are still thinking of you! In this release we've improved our buttons a bit more so that VoiceOver will tell you whether a button is disabled or busy. More improvements to come!",
      currentVersionReleaseDate: '2020-09-14T17:28:43Z',
      minimumOsVersion: '11.0',
      formattedPrice: 'Free',
      isVppDeviceBasedLicensingEnabled: true,
      genreIds: ['6015', '6012'],
      primaryGenreName: 'Finance',
      releaseDate: '2014-03-16T05:21:25Z',
      version: '5.45.0',
      wrapperType: 'software',
      currency: 'USD',
      artistId: 836215272,
      artistName: 'Chime Financial, Inc.',
      genres: ['Finance', 'Lifestyle'],
      price: 0.0,
      description:
        'Chime is mobile and online banking with no hidden fees: get your paycheck up to 2 days early* with direct deposit, have fee-free overdraft when you’re in a pinch, grow your savings automatically, and manage your finances like a boss using the highly-rated Chime mobile banking app.\n\nWhen you bank with Chime, you get a Visa® Debit Card, a Spending Account, and an optional Savings Account to help you save money. \n\nApplying for an account is free, takes less than 2 minutes and it won’t affect your credit score!\n\nHere’s what our members love most about Chime:\n• Get your paycheck up to 2 days early* with direct deposit\n• Fee-free overdraft.** We’ll spot you on debit card purchases with no overdraft fees. \n• No hidden fees: no monthly fees, no overdraft fees, no foreign transaction fees, no minimum balance requirements \n• Over 38,000 fee-free ATMs with Moneypass and Visa Plus Alliance\n• Real-time transaction notifications\n• Daily balance alerts\n• Block your card instantly in-app\n• Grow your savings automatically with our Savings Account\n• Send money instantly with Pay Friends to other Chime members. \n• Deposit checks using Mobile Check Deposit for eligible members.^ \n• Apple Pay™ / Google Pay™ for when you forget your wallet\n• Move money between your other bank accounts\n• EMV chip card security\n• Friendly and responsive customer support\n\nWith the Chime mobile banking app, you can stay in control of your money. Track your spending, link your other bank accounts, and save money.\n\nHow to switch banks:\n• Step 1: Open Your Account: Download the app and sign up. Once approved, we’ll send you your Chime card within two weeks!\n• Step 2: Fund Your Account: Set up a direct deposit with your employer or payer to have funds deposited to your Chime account every payday. You can also connect other bank accounts and transfer funds from your existing bank account.\n• Step 3: Update Bill Payments: Activate your card when it arrives, add it to Apple Pay, and set up recurring bill payments with your Chime card number or with your Chime Spending Account and routing numbers.\n\nFor more information please visit www.chime.com.\n\n***Learn how we collect and use your information by visiting our Privacy Policy at https://www.chimebank.com/policies/chime/privacy-policy/.***\n\nBanking services provided by, and debit card issued by, The Bancorp Bank, or Stride Bank, N.A., Members FDIC, pursuant to a license from Visa U.S.A. Inc. Debit card may be used everywhere Visa debit cards are accepted.\n\n*Early access to direct deposit funds depends on the timing of payer’s submission of deposits. We generally post such deposits on the day they are received which may be up to 2 days earlier than the payer’s scheduled payment date.\n**Chime SpotMe is an optional, no fee service that requires that you receive $500 in direct deposit a month to qualify to overdraw your account up to $20 on debit card purchases. Chime, in its sole discretion, may allow you to withdraw your account up to $100 or more based on your Chime Account history, direct deposit history and amount, spending activity and other risk-based factors. Your Limit will be displayed to you within the Chime mobile app. You will receive notice of any changes to your Limit. Your Limit may be increased or lowered at any time by Chime.\n^Not all new or existing customers are eligible to use Mobile Deposit. There are qualifications and enrollment requirements for participation in Mobile Deposit, and we reserve the right to change the qualification and enrollment requirements in our sole discretion at any time without prior notice. We may require you to upload a picture of your driver’s license or other identifying documents prior to using Mobile Deposit. Eligibility requirements can be found online after you have signed into your Spending Account.',
      bundleId: 'com.1debit.ChimeProdApp',
      userRatingCount: 174981,
    },
  ],
};
